module.exports = {
	"commonComment": {
		"en": "Comments",
		"tw": "回帖",
		"hk": "回帖",
		"cn": "回帖"
	},
	"commonTopic": {
		"en": "Topic",
		"tw": "主帖",
		"hk": "主帖",
		"cn": "主帖"
	},
	"commonSort": {
		"en": "Sort",
		"tw": "排序",
		"hk": "排序",
		"cn": "排序"
	},
	"commonDone": {
		"en": "Done",
		"tw": "完成",
		"hk": "完成",
		"cn": "完成"
	},
	"commonCreate": {
		"en": "Create",
		"tw": "創建",
		"hk": "創建",
		"cn": "创建"
	},
	"commonAll": {
		"en": "All",
		"hk": "全部",
		"tw": "全部",
		"cn": "全部"
	},
	"commonCompress": {
		"en": "Compress",
		"tw": "收起",
		"hk": "收起",
		"cn": "收起"
	},
	"commonExpand": {
		"en": "Expand",
		"tw": "展開",
		"hk": "展開",
		"cn": "展开"
	},
	"commonCompare": {
		"en": "Compare",
		"tw": "對比",
		"hk": "對比",
		"cn": "对比"
	},
	"commonSujectName": {
		"en": "Suject Name",
		"tw": "話題名稱",
		"hk": "話題名稱",
		"cn": "话题名称"
	},
	"commonSelectMedia": {
		"en": "Select Media",
		"tw": "選擇媒體",
		"hk": "選擇媒體",
		"cn": "选择媒体"
	},
	"commonKeyword": {
		"en": "Keyword",
		"tw": "關鍵字",
		"hk": "關鍵字",
		"cn": "关键字"
	},
	"commonRegion": {
		"en": "Region",
		"tw": "地區",
		"hk": "地區",
		"cn": "地区"
	},
	"commonExcludeKeyword": {
		"en": "Excluded Keywords",
		"tw": "排除字",
		"hk": "排除字",
		"cn": "排除字"
	},
	"commonPeriod": {
		"en": "Period",
		"tw": "時間範圍",
		"hk": "時間範圍",
		"cn": "时间范围"
	},
	"commonDateScreen": {
		"en": "Date Screen",
		"tw": "日期篩選",
		"hk": "日期篩選",
		"cn": "日期筛选"
	},
	"commonRange": {
		"en": "Range",
		"tw": "週期",
		"hk": "週期",
		"cn": "周期"
	},
	"commonThreshold": {
		"en": "Threshold",
		"tw": "閾值",
		"hk": "閾值",
		"cn": "阈值"
	},
	"year": {
		"en": "Year",
		"tw": "按年",
		"hk": "按年",
		"cn": "按年"
	},
	"month": {
		"en": "Month",
		"tw": "按月",
		"hk": "按月",
		"cn": "按月"
	},
	"day": {
		"en": "Day",
		"tw": "按天",
		"hk": "按天",
		"cn": "按天"
	},
	"hour": {
		"en": "Hour",
		"tw": "按小時",
		"hk": "按小時",
		"cn": "按小时"
	},
	"commonHour": {
		"en": "Hour",
		"tw": "小時",
		"hk": "小時",
		"cn": "小时"
	},
	"commonPrevious": {
		"en": "Previous",
		"tw": "上一步",
		"hk": "上一步",
		"cn": "上一步"
	},
	"commonNext": {
		"en": "Next",
		"tw": "下一步",
		"hk": "下一步",
		"cn": "下一步"
	},
	"commonPositive": {
		"en": "Positive",
		"tw": "正面",
		"hk": "正面",
		"cn": "正面"
	},
	"commonNegative": {
		"en": "Negative",
		"tw": "負面",
		"hk": "負面",
		"cn": "负面"
	},
	"commonDetail": {
		"en": "Detail",
		"tw": "詳情",
		"hk": "詳情",
		"cn": "详情"
	},
	"commonEdit": {
		"en": "Edit",
		"tw": "編輯",
		"hk": "編輯",
		"cn": "编辑"
	},
	"commonOverview": {
		"en": "Overview",
		"tw": "總覽",
		"hk": "總覽",
		"cn": "总览"
	},
	"commonSource": {
		"en": "Source",
		"tw": "媒體來源",
		"hk": "媒體來源",
		"cn": "媒体来源"
	},
	"commonPool": {
		"en": "Coding Pool",
		"tw": "編碼庫",
		"hk": "編碼庫",
		"cn": "编码库"
	},
	"commonTestingPool": {
		"en": "Testing Pool",
		"tw": "測試庫",
		"hk": "測試庫",
		"cn": "测试库"
	},
	"commonRemovedPool": {
		"en": "Trash Pool",
		"tw": "回收庫",
		"hk": "回收庫",
		"cn": "回收库"
	},
	"commonSetting": {
		"en": "Setting",
		"tw": "設定",
		"hk": "設定",
		"cn": "设定"
	},
	"commonTime": {
		"en": "Period",
		"tw": "時間",
		"hk": "時間",
		"cn": "时间"
	},
	"commonSelectAll": {
		"en": "Select All",
		"tw": "全選",
		"hk": "全選",
		"cn": "全选"
	},
	"commonDownload": {
		"en": "Download",
		"tw": "下載",
		"hk": "下載",
		"cn": "下载"
	},
	"commonDownloading": {
		"en": "Downloading",
		"tw": "下載中",
		"hk": "下載中",
		"cn": "下载中"
	},
	"commonClipping": {
		"en": "Clipping",
		"tw": "剪報",
		"hk": "剪報",
		"cn": "剪报"
	},
	"commonClippingCount": {
		"en": "No. of Clippings ： {{count}}",
		"tw": "剪報筆數： {{count}}",
		"hk": "剪報筆數： {{count}}",
		"cn": "剪报条数： {{count}}"
	},
	"commonFavorites": {
		"en": "Favorites",
		"tw": "收藏",
		"hk": "收藏",
		"cn": "收藏"
	},
	"commonSearchCondition": {
		"en": "Search Conditions",
		"tw": "查詢條件",
		"hk": "查詢條件",
		"cn": "查询条件"
	},
	"commonMedia": {
		"en": "Media Source",
		"tw": "媒體類型",
		"hk": "媒體類型",
		"cn": "媒体类型"
	},
	"commonPrice": {
		"en": "Price",
		"tw": "價格",
		"hk": "價格",
		"cn": "价格"
	},
	"commonWords": {
		"en": "Words",
		"hk": "字數",
		"tw": "字數",
		"cn": "字数"
	},
	"commonToday": {
		"en": "Today",
		"tw": "今日",
		"hk": "今日",
		"cn": "今日"
	},
	"commonPastAWeek": {
		"en": "Last 7 days",
		"tw": "過去7天",
		"hk": "過去7天",
		"cn": "过去7天"
	},
	"commonPastAMonth": {
		"en": "Last 30 days",
		"tw": "過去30天",
		"hk": "過去30天",
		"cn": "过去30天"
	},
	"commonBlog": {
		"en": "Blog",
		"tw": "部落格",
		"hk": "博客",
		"cn": "博客"
	},
	"commonVideo": {
		"en": "Video",
		"tw": "視頻",
		"hk": "視頻",
		"cn": "视频"
	},
	"commonMacauTalk": {
		"en": "MacauTalk",
		"tw": "澳門講場",
		"hk": "澳門講場",
		"cn": "澳门讲场"
	},
	"commonNews": {
		"en": "News",
		"hk": "新聞",
		"tw": "新聞",
		"cn": "新闻"
	},
	"commonForum": {
		"en": "Forum",
		"tw": "論壇",
		"hk": "論壇",
		"cn": "论坛"
	},
	"commonForumComment": {
		"en": "Forum",
		"tw": "論壇",
		"hk": "論壇",
		"cn": "论坛"
	},
	"commonFacebook": {
		"en": "Facebook",
		"tw": "Facebook",
		"hk": "Facebook",
		"cn": "Facebook"
	},
	"commonTwitter": {
		"en": "Twitter",
		"tw": "Twitter",
		"hk": "Twitter",
		"cn": "Twitter"
	},
	"commonWechat": {
		"en": "Wechat",
		"tw": "微信",
		"hk": "微信",
		"cn": "微信"
	},
	"commonPage": {
		"en": "Page",
		"tw": "專頁",
		"hk": "專頁",
		"cn": "专页"
	},
	"commonGoods": {
		"en": "Goods",
		"tw": "商品",
		"hk": "商品",
		"cn": "商品"
	},
	"commonHits": {
		"en": "Views",
		"tw": "閱讀數",
		"hk": "閱讀數",
		"cn": "阅读数"
	},
	"commonComments": {
		"en": "Comments",
		"tw": "評論數",
		"hk": "評論數",
		"cn": "评论数"
	},
	"commonLikes": {
		"en": "Likes",
		"tw": "讚好數",
		"hk": "讚好數",
		"cn": "点赞数"
	},
	"commonShares": {
		"en": "Shares",
		"tw": "分享數",
		"hk": "分享數",
		"cn": "分享数"
	},
	"commonHotvalue": {
		"en": "Hot value",
		"tw": "熱度值",
		"hk": "熱度值",
		"cn": "热度值"
	},
	"commonBy": {
		"en": "Author",
		"tw": "作者",
		"hk": "作者",
		"cn": "作者"
	},
	"commonCodeBy": {
		"en": "Coder",
		"tw": "編碼員",
		"hk": "編碼員",
		"cn": "编码员"
	},
	"commonReputation": {
		"en": "Reputation",
		"tw": "美譽度",
		"hk": "美譽度",
		"cn": "美誉度"
	},
	"commonTrend": {
		"en": "Buzz Trend",
		"tw": "趨勢",
		"hk": "趨勢",
		"cn": "趋势"
	},
	"commonSentiment": {
		"en": "Sentiment",
		"tw": "情感",
		"hk": "情感",
		"cn": "情感"
	},
	"commonNoData": {
		"en": "No data",
		"tw": "沒有數據",
		"hk": "沒有數據",
		"cn": "没有数据"
	},
	"clickPlusToCreate": {
		"en": "Click \"+\" to create",
		"tw": "單擊“+”開始創建",
		"hk": "單擊“+”開始創建",
		"cn": "点击“+”开始创建"
	},
	"keywordsError": {
		"en": "Keyword syntax error",
		"tw": "關鍵字詞法錯誤",
		"hk": "關鍵字詞法錯誤",
		"cn": "关键字词法错误"
	},
	"resetKeyword": {
		"en": "Please check and edit keywords",
		"tw": "請檢查并修改關鍵詞",
		"hk": "請檢查并修改關鍵詞",
		"cn": "请检查并修改关键词"
	},
	"commonAlertDescription": {
		"en": "Change search conditions for more results.",
		"hk": "可以改變條件查看更多內容",
		"tw": "可以改變條件查看更多內容",
		"cn": "可以改变条件查看更多内容"
	},
	"commonConfirm": {
		"en": "Confirm",
		"hk": "確定",
		"tw": "確定",
		"cn": "确定"
	},
	"commonPlease": {
		"en": "Please",
		"tw": "請",
		"hk": "請",
		"cn": "请"
	},
	"commonStartDate": {
		"en": "Start Date",
		"tw": "開始時間",
		"hk": "開始時間",
		"cn": "开始时间"
	},
	"commonEndDate": {
		"en": "End Date",
		"tw": "結束時間",
		"hk": "結束時間",
		"cn": "结束时间"
	},
	"commonDelete": {
		"en": "Delete",
		"tw": "刪除",
		"hk": "刪除",
		"cn": "删除"
	},
	"commonSuccess": {
		"en": "Success",
		"tw": "成功",
		"hk": "成功",
		"cn": "成功"
	},
	"commonTitle": {
		"en": "Title",
		"hk": "標題",
		"tw": "標題",
		"cn": "标题"
	},
	"commonContent": {
		"en": "Content",
		"hk": "內容",
		"tw": "內容",
		"cn": "内容"
	},
	"commonDistribution": {
		"en": "Distribution",
		"hk": "分佈",
		"tw": "分佈",
		"cn": "分布"
	},
	"commonFrom": {
		"en": "Source",
		"tw": "來源",
		"hk": "來源",
		"cn": "来源"
	},
	"commonIn": {
		"en": "Section",
		"hk": "板塊",
		"tw": "板塊",
		"cn": "板块"
	},
	"commonDate": {
		"en": "Publish Time",
		"tw": "發佈時間",
		"hk": "發佈時間",
		"cn": "发布时间"
	},
	"commonOperation": {
		"en": "Controller",
		"hk": "操作",
		"tw": "操作",
		"cn": "操作"
	},
	"commonOperationPeopel": {
		"en": "Operator",
		"tw": "操作人",
		"hk": "操作人",
		"cn": "操作人"
	},
	"commonRecover": {
		"en": "Recover",
		"hk": "恢復",
		"tw": "恢復",
		"cn": "恢复"
	},
	"commonShowTotal": {
		"en": "About {{total}} results",
		"hk": "共 {{total}} 條",
		"tw": "共 {{total}} 條",
		"cn": "共 {{total}} 条"
	},
	"commonSave": {
		"en": "Save",
		"hk": "保存",
		"tw": "保存",
		"cn": "保存"
	},
	"commonSaveing": {
		"en": "Saving",
		"hk": "保存中",
		"tw": "保存中",
		"cn": "保存中"
	},
	"commonCancel": {
		"en": "Cancel",
		"tw": "取消",
		"hk": "取消",
		"cn": "取消"
	},
	"commonAdd": {
		"en": "Add",
		"tw": "添加",
		"hk": "添加",
		"cn": "添加"
	},
	"commonKeySupportPlaceholder": {
		"en": "Support the AND/OR combination of keywords",
		"tw": "可支持 AND/OR 組合關鍵字",
		"hk": "可支持 AND/OR 組合關鍵字",
		"cn": "可支持 AND/OR 组合关键字"
	},
	"commonDeleteSuccess": {
		"en": "Success",
		"tw": "刪除成功",
		"hk": "刪除成功",
		"cn": "删除成功"
	},
	"commonAddSuccess": {
		"en": "Success",
		"tw": "添加成功",
		"hk": "添加成功",
		"cn": "添加成功"
	},
	"commonSaveSuccess": {
		"en": "Success",
		"tw": "保存成功",
		"hk": "保存成功",
		"cn": "保存成功"
	},
	"commonAdvanceSetting": {
		"en": "Advanced Settings",
		"tw": "進階設定",
		"hk": "進階設定",
		"cn": "进阶设定"
	},
	"commonCount": {
		"en": "Total",
		"hk": "總數",
		"tw": "總數",
		"cn": "总数"
	},
	"commonAverage": {
		"en": "Average",
		"hk": "平均值",
		"tw": "平均值",
		"cn": "平均值"
	},
	"commonMax": {
		"en": "Maximum",
		"hk": "最大值",
		"tw": "最大值",
		"cn": "最大值"
	},
	"commonMin": {
		"en": "Minimum",
		"hk": "最小值",
		"tw": "最小值",
		"cn": "最小值"
	},
	"commonMember": {
		"en": "Members",
		"tw": "成員",
		"hk": "成員",
		"cn": "成员"
	},
	"commonAlert": {
		"en": "Alert",
		"tw": "預警",
		"hk": "預警",
		"cn": "预警"
	},
	"commonAnalysis": {
		"en": "Analysis",
		"tw": "分析",
		"hk": "分析",
		"cn": "分析"
	},
	"commonAnalysisList": {
		"en": "Profiles",
		"tw": "圖表庫",
		"hk": "圖表庫",
		"cn": "图表库"
	},
	"commonAnalysisEditor": {
		"en": "Edit",
		"hk": "編輯圖表",
		"tw": "編輯圖表",
		"cn": "编辑图表"
	},
	"commonSearch": {
		"en": "Search",
		"hk": "搜索",
		"tw": "搜索",
		"cn": "搜索"
	},
	"enterLabelId": {
		"en": "Input Label ID",
		"tw": "鍵入分類ID",
		"hk": "鍵入分類ID",
		"cn": "输入分类ID"
	},
	"enterToContinu": {
		"en": "Input & Press 'Enter'",
		"tw": "鍵入字符并回車",
		"hk": "鍵入字符并回車",
		"cn": "输入字符并回车"
	},
	"createSubjectLabel": {
		"en": "Create subject category",
		"tw": "創建話題分類",
		"hk": "創建話題分類",
		"cn": "创建话题分类"
	},
	"deleteFromLabel": {
		"en": "Delete from this category",
		"tw": "從當前分類中移除",
		"hk": "從當前分類中移除",
		"cn": "从当前分类中移除"
	},
	"labelNameIsRequired": {
		"en": "Label name is required",
		"hk": "分類名稱不能為空",
		"tw": "分類名稱不能為空",
		"cn": "分类名称不能为空"
	},
	"commonItem": {
		"en": "Category",
		"tw": "類目",
		"hk": "類目",
		"cn": "类目"
	},
	"CategoryTable": {
		"en": "Category Table",
		"tw": "類目表",
		"hk": "類目表",
		"cn": "类目表"
	},
	"commonLittleCount": {
		"en": "Subtotal",
		"hk": "小計",
		"tw": "小計",
		"cn": "小计"
	},
	"commonPercentage": {
		"en": "Percentage",
		"tw": "百分比",
		"hk": "百分比",
		"cn": "百分比"
	},
	"commonFilter": {
		"en": "Filter",
		"hk": "篩選",
		"tw": "篩選",
		"cn": "筛选"
	},
	"commonModify": {
		"en": "Edit",
		"tw": "修改",
		"hk": "修改",
		"cn": "修改"
	},
	"commonFeedback": {
		"en": "Feedback",
		"tw": "留言",
		"hk": "留言",
		"cn": "留言"
	},
	"commonCliped": {
		"en": "Clipped",
		"hk": "已剪",
		"tw": "已剪",
		"cn": "已剪"
	},
	"commonClippingSuccess": {
		"en": "Collection Success",
		"hk": "收藏成功",
		"tw": "收藏成功",
		"cn": "收藏成功"
	},
	"commonClippingFail": {
		"en": "Collection Fail",
		"hk": "收藏失敗",
		"tw": "收藏失敗",
		"cn": "收藏失败"
	},
	"commonClippingFull": {
		"en": "Collection Full",
		"hk": "收藏夾已滿",
		"tw": "收藏夾已滿",
		"cn": "收藏夹已满"
	},
	"commonRegister": {
		"en": "Register",
		"hk": "註冊",
		"tw": "註冊",
		"cn": "注册"
	},
	"commonLogin": {
		"en": "Login",
		"hk": "登錄",
		"tw": "登錄",
		"cn": "登录"
	},
	"commonLoginTitle": {
		"en": "Please Login or Register",
		"hk": "請閣下先行註冊/登錄",
		"tw": "請閣下先行註冊/登錄",
		"cn": "请阁下先行注册/登录"
	},
	"commonLoginContent": {
		"en": "you can check the collections after login",
		"hk": "登錄後，可查看收藏記錄",
		"tw": "登錄後，可查看收藏記錄",
		"cn": "登陆后，可查看收藏记录"
	},
	"commonClickLoadingMore": {
		"en": "More",
		"tw": "點擊加載更多",
		"hk": "點擊加載更多",
		"cn": "点击加载更多"
	},
	"commonTextLink": {
		"en": "Origin",
		"hk": "原文鏈接",
		"tw": "原文鏈接",
		"cn": "原文链接"
	},
	"commonTest": {
		"en": "Test",
		"hk": "測試",
		"tw": "測試",
		"cn": "测试"
	},
	"commonAlertWords": {
		"en": "Articles",
		"hk": "文章數",
		"tw": "文章數",
		"cn": "文章数"
	},
	"commonZhi": {
		"en": "To",
		"hk": "至",
		"tw": "至",
		"cn": "至"
	},
	"commonQuit": {
		"en": "Log out",
		"hk": "登出",
		"tw": "登出",
		"cn": "退出"
	},
	"commonMessage": {
		"en": "Message",
		"hk": "消息",
		"tw": "消息",
		"cn": "消息"
	},
	"updateSubjectWarning": {
		"en": "Notice! This step will modify subject settings.",
		"hk": "注意！此操作將會更新話題設定。",
		"tw": "注意！此操作將會更新話題設定。",
		"cn": "注意！此操作将会更新话题设定。"
	},
	"menuSubject": {
		"en": "Subjects",
		"hk": "話題",
		"tw": "話題",
		"cn": "话题"
	},
	"menuDiscovery": {
		"en": "Discoveries",
		"hk": "發現",
		"tw": "發現",
		"cn": "发现"
	},
	"menuAnalysis": {
		"en": "Analysis",
		"hk": "分析",
		"tw": "分析",
		"cn": "分析"
	},
	"menuClipping": {
		"en": "Clipping",
		"hk": "剪報",
		"tw": "剪報",
		"cn": "剪报"
	},
	"discoveryMenuRecommend": {
		"en": "Discoveries",
		"hk": "發現",
		"tw": "發現",
		"cn": "发现"
	},
	"discoveryMenuNewest": {
		"en": "Latest",
		"hk": "最新資訊",
		"tw": "最新資訊",
		"cn": "最新资讯"
	},
	"discoveryMenuHeadline": {
		"en": "News Headline",
		"hk": "新聞頭條",
		"tw": "新聞頭條",
		"cn": "新闻头条"
	},
	"discoveryMenuHotSocial": {
		"en": "Facebook Hots",
		"hk": "臉書熱點",
		"tw": "臉書熱點",
		"cn": "脸书热点"
	},
	"discoveryMenuHotForum": {
		"en": "Forum Hots",
		"hk": "論壇熱點",
		"tw": "論壇熱點",
		"cn": "论坛热点"
	},
	"discoveryMenuCityFocus": {
		"en": "Public Focus",
		"hk": "全民關注",
		"tw": "全民關注",
		"cn": "全民关注"
	},
	"discoveryRollBack": {
		"en": "Back",
		"hk": "回到上一層",
		"tw": "回到上一層",
		"cn": "回到上一层"
	},
	"discoveryControlInputKeyPlaceholder": {
		"en": "Keyword",
		"hk": "輸入關鍵詞",
		"tw": "輸入關鍵詞",
		"cn": "输入关键词"
	},
	"discoveryListTotal": {
		"en": "About {{total}} results",
		"hk": "總共 {{total}} 條記錄",
		"tw": "總共 {{total}} 條記錄",
		"cn": "总共 {{total}} 条记录"
	},
	"discoveryModeList": {
		"en": "List Mode",
		"hk": "列表模式",
		"tw": "列表模式",
		"cn": "列表模式"
	},
	"discoveryModeTable": {
		"en": "Table Mode",
		"hk": "表格模式",
		"tw": "表格模式",
		"cn": "表格模式"
	},
	"modeCard": {
		"en": "Card Mode",
		"hk": "卡片模式",
		"tw": "卡片模式",
		"cn": "卡片模式"
	},
	"clippingPanelRemoveTitle": {
		"en": "Are you sure to empty the clipping list?",
		"hk": "確定要清空剪報列表嗎？",
		"tw": "確定要清空剪報列表嗎？",
		"cn": "确定要清空剪报列表吗？"
	},
	"clippingPanelRemoveDescription": {
		"en": "Attention! Clipping list cannot be recovered after being emptied.",
		"hk": "請注意：剪報列表清空後將無法恢復。",
		"tw": "請注意：剪報列表清空後將無法恢復。",
		"cn": "请注意：剪报列表清空后将无法恢复。"
	},
	"clippingPanelClosePanel": {
		"en": "Close",
		"hk": "關閉面板",
		"tw": "關閉面板",
		"cn": "关闭面板"
	},
	"clippingPanelRemoveList": {
		"en": "Empty",
		"hk": "清空列表",
		"tw": "清空列表",
		"cn": "清空列表"
	},
	"clippingPanelDownload": {
		"en": "Download",
		"hk": "下載數據",
		"tw": "下載數據",
		"cn": "下载数据"
	},
	"subjectHeaderList": {
		"en": "Subject List",
		"hk": "話題列表",
		"tw": "話題列表",
		"cn": "话题列表"
	},
	"subjectListTitle": {
		"en": "About {{count}} results",
		"hk": "總共有 {{count}} 個話題",
		"tw": "總共有 {{count}} 個話題",
		"cn": "总共有 {{count}} 个话题"
	},
	"subjectListExceed": {
		"en": "You've reached the subject limit.",
		"hk": "閣下設定的話題數量已達上限",
		"tw": "閣下設定的話題數量已達上限",
		"cn": "阁下设定的话题数量已达上限"
	},
	"subjectHeaderCompare": {
		"en": "Compare",
		"hk": "話題對比",
		"tw": "話題對比",
		"cn": "话题对比"
	},
	"subjectCompare": {
		"en": "Compare",
		"hk": "話題對比",
		"tw": "話題對比",
		"cn": "话题对比"
	},
	"subjectListCreateSubject": {
		"en": "Create",
		"hk": "創建話題",
		"tw": "創建話題",
		"cn": "创建话题"
	},
	"subjectFirstInit": {
		"en": "No subject. Please click here to",
		"hk": "沒有檢索到任何話題，點擊這裡",
		"tw": "沒有檢索到任何話題，點擊這裡",
		"cn": "没有搜索到任何话题，点击这里"
	},
	"subjectFirstInitText": {
		"en": "No subject.",
		"hk": "沒有檢索到任何話題",
		"tw": "沒有檢索到任何話題",
		"cn": "没有搜索到任何话题"
	},
	"subjectGroup": {
		"en": "Subject Categories",
		"hk": "話題分類",
		"tw": "話題分類",
		"cn": "话题分类"
	},
	"subjectCompareLimitDescriptionOne": {
		"en": "Subjects have been added. Maximum of five subjects for comparison",
		"hk": "話題已加入比較，最多可選取5個話題",
		"tw": "話題已加入比較，最多可選取5個話題",
		"cn": "话题已加入比较，最多可选取5个话题"
	},
	"subjectCompareLimitDescriptionTwo": {
		"en": "for optimal visualization",
		"hk": "以便獲得最優可視化呈現",
		"tw": "以便獲得最優可視化呈現",
		"cn": "以便获得最优可视化呈现"
	},
	"subjectCreateStepOne": {
		"en": "1.Fill in subject name",
		"hk": "1、填寫話題名稱",
		"tw": "1、填寫話題名稱",
		"cn": "1、填写话题名称"
	},
	"subjectNameRequired": {
		"en": "Subject name is required",
		"hk": "話題名稱為必填",
		"tw": "話題名稱為必填",
		"cn": "话题名称为必填"
	},
	"subjectCreateStepTwo": {
		"en": "2. Choose media type",
		"hk": "2、選擇需要關注的媒體類型",
		"tw": "2、選擇需要關注的媒體類型",
		"cn": "2、选择需要关注的媒体类型"
	},
	"subjectCreateStepThree": {
		"en": "3. Setup the common keywords for all media type",
		"hk": "3、設置全部媒體類型公用的關鍵字",
		"tw": "3、設置全部媒體類型公用的關鍵字",
		"cn": "3、设置全部媒体类型公用的关键字"
	},
	"subjectCreateStepFour": {
		"en": "4. Setup the common excluded words for all media type",
		"hk": "4、設置全部媒體類型公用的排除字",
		"tw": "4、設置全部媒體類型公用的排除字",
		"cn": "4、设置全部媒体类型公用的排除字"
	},
	"subjectCreateStepFive": {
		"en": "5. Setup the monitoring period for for subject",
		"hk": "5、設置話題的監測時間範圍",
		"tw": "5、設置話題的監測時間範圍",
		"cn": "5、设置话题的监测时间范围"
	},
	"subjectCanSkip": {
		"en": "(Continue to monitor subject can skip this setting)",
		"hk": "（持續監測話題可跳過此設置）",
		"tw": "（持續監測話題可跳過此設置）",
		"cn": "（持续监测话题可跳过此设置）"
	},
	"subjectCreateStepSix": {
		"en": "6. Test your settings",
		"hk": "6、測試設定",
		"tw": "6、測試設定",
		"cn": "6、测试设定"
	},
	"subjectCreateStepSeven": {
		"en": "7. Setup Alert",
		"hk": "7、設置預警",
		"tw": "7、設置預警",
		"cn": "7、设置预警"
	},
	"subjectCompareHasBeenSelected": {
		"en": "This subject is in the comparison list",
		"hk": "該話題已在對比列表中",
		"tw": "該話題已在對比列表中",
		"cn": "该话题已在对比列表中"
	},
	"subjectCompareAboveTheQuota": {
		"en": "Maximum of 5 subjects for comparison",
		"hk": "最多只能對5個話題進行對比！",
		"tw": "最多只能對5個話題進行對比！",
		"cn": "最多只能对5个话题进行对比！"
	},
	"subjectRealTimeDataTooltip": {
		"en": "From 00:00:00 until now",
		"hk": "今日凌晨00:00:00到當前時刻",
		"tw": "今日凌晨00:00:00到當前時刻",
		"cn": "今日凌晨00:00:00到当前时刻"
	},
	"subjectRealTime": {
		"en": "Real Time",
		"hk": "實時",
		"tw": "實時",
		"cn": "实时"
	},
	"subjectAddToCompare": {
		"en": "Add to Compare",
		"hk": "加入對比",
		"tw": "加入對比",
		"cn": "加入对比"
	},
	"subjectSortSuccess": {
		"en": "Sorting success",
		"hk": "排序成功",
		"tw": "排序成功",
		"cn": "排序成功"
	},
	"subjectDetailMonitoring": {
		"en": "Monitoring",
		"hk": "監測",
		"tw": "監測",
		"cn": "监测"
	},
	"subjectReturnToSubjectList": {
		"en": "Return to the subject list",
		"hk": "返回話題列表",
		"tw": "返回話題列表",
		"cn": "返回话题列表"
	},
	"subjectContentData": {
		"en": "Data",
		"hk": "內容數據",
		"tw": "內容數據",
		"cn": "内容数据"
	},
	"subjectKeywordExisted": {
		"en": "This keyword existed already.",
		"hk": "該關鍵字已存在",
		"tw": "該關鍵字已存在",
		"cn": "该关键字已存在"
	},
	"subjectMonitoringFeedFrom": {
		"en": "From",
		"hk": "來自",
		"tw": "來自",
		"cn": "来自"
	},
	"subjectMonitoringFeedAt": {
		"en": "At",
		"hk": "於",
		"tw": "於",
		"cn": "于"
	},
	"subjectsMonitoringFeedListNoMessage": {
		"en": "No data",
		"hk": "沒有相關數據",
		"tw": "沒有相關數據",
		"cn": "沒有相關數據"
	},
	"subjectsMonitoringFeedListChangeCondition": {
		"en": "Change search conditions for more results",
		"hk": "可以改變條件查看更多內容",
		"tw": "可以改變條件查看更多內容",
		"cn": "可以改变条件查看更多内容"
	},
	"subjectsMonitoringFeedListTotal": {
		"en": "About {{total}} results",
		"hk": "共 {{total}} 條",
		"tw": "共 {{total}} 條",
		"cn": "共 {{total}} 条"
	},
	"subjectOpinionLeaderDescription": {
		"en": "In active netizen statistical, most active netizen respectively are",
		"hk": "活躍網民統計中, 最活躍的網民排行分別是",
		"tw": "活躍網民統計中, 最活躍的網民排行分別是",
		"cn": "活跃网民统计中, 最活跃的网民排行分别是"
	},
	"subjectOpinionLeaderStatistic": {
		"en": "【{{user}}】 post {{count}} articles",
		"hk": "【{{user}}】 發佈文章 {{count}} 篇",
		"tw": "【{{user}}】 發佈文章 {{count}} 篇",
		"cn": "【{{user}}】 发布文章 {{count}} 篇"
	},
	"subjectSampleManagement": {
		"en": "Pooling Management",
		"hk": "數據管理",
		"tw": "數據管理",
		"cn": "建库管理"
	},
	"AlertManagement": {
		"en": "Alert Management",
		"hk": "預警管理",
		"tw": "預警管理",
		"cn": "预警管理"
	},
	"subjectCategorization": {
		"en": "Categorization",
		"hk": "類目管理",
		"tw": "類目管理",
		"cn": "类目管理"
	},
	"subjectRTesting": {
		"en": "R. Testing",
		"hk": "信度測試",
		"tw": "信度測試",
		"cn": "信度测试"
	},
	"subjectCoding": {
		"en": "Coding",
		"hk": "內容編碼",
		"tw": "內容編碼",
		"cn": "内容编码"
	},
	"subjectQualityControl": {
		"en": "Quality Control",
		"hk": "質量監控",
		"tw": "質量監控",
		"cn": "质量监控"
	},
	"subjectMonitoringTimelinePropagationPath": {
		"en": "Communication Path",
		"hk": "傳播路徑",
		"tw": "傳播路徑",
		"cn": "传播路径"
	},
	"subjectMonitoringTrendVolumeTrend": {
		"en": "Trend",
		"hk": "聲量趨勢",
		"tw": "聲量趨勢",
		"cn": "声量趋势"
	},
	"subjectCompareVolumeSource": {
		"en": "Buzz Trend",
		"hk": "聲量分佈",
		"tw": "聲量分佈",
		"cn": "声量分布"
	},
	"subjectCompareHotSource": {
		"en": "Buzz Distribution",
		"hk": "熱門来源",
		"tw": "熱門来源",
		"cn": "热门来源"
	},
	"subjectMonitoringWordcloud": {
		"en": "Word Cloud",
		"hk": "焦點熱詞",
		"tw": "焦點熱詞",
		"cn": "焦点热词"
	},
	"subjectMonitoringWordcloudWhat": {
		"en": "Topics were discussed",
		"hk": "網民討論什麼",
		"tw": "網民討論什麼",
		"cn": "网民讨论什么"
	},
	"subjectMonitoringWordcloudHow": {
		"en": "How was discussed",
		"hk": "網民怎麼討論",
		"tw": "網民怎麼討論",
		"cn": "网民怎么讨论"
	},
	"subjectOpinionLeader": {
		"en": "Active users",
		"hk": "活躍網民",
		"tw": "活躍網民",
		"cn": "活跃网民"
	},
	"subjectOpinionLeaderFeedList": {
		"en": "Feed List",
		"hk": "帖子列表",
		"tw": "帖子列表",
		"cn": "帖子列表"
	},
	"subjectOpinionLeaderFeedCount": {
		"en": "Feeds",
		"hk": "發帖數",
		"tw": "發帖數",
		"cn": "发帖数"
	},
	"subjectPoolingOverviewPooledTime": {
		"en": "Recent exacted time",
		"hk": "最近入庫時間",
		"tw": "最近入庫時間",
		"cn": "最近入库时间"
	},
	"subjectPoolingTopicOverviewPooledCount": {
		"en": "Extracted topic {{pooledCount}}",
		"hk": "已入庫主帖 {{pooledCount}} 筆",
		"tw": "已入庫主帖 {{pooledCount}} 筆",
		"cn": "已入库主帖 {{pooledCount}} 条"
	},
	"subjectPoolingOverviewPooledCount": {
		"en": "Extracted {{pooledCount}}",
		"hk": "已入庫 {{pooledCount}} 筆",
		"tw": "已入庫 {{pooledCount}} 筆",
		"cn": "已入库 {{pooledCount}} 条"
	},
	"SubjectPoolingOverviewNewlyAddedCount": {
		"en": "New added {{increment}}",
		"hk": "新增 {{increment}} 筆",
		"tw": "新增 {{increment}} 筆",
		"cn": "新增 {{increment}} 条"
	},
	"subjectPoolingMarked": {
		"en": "Please select the task to extract data",
		"hk": "請選擇任務提取數據",
		"tw": "請選擇任務提取數據",
		"cn": "请选择任务提取数据"
	},
	"subjectPoolingOverviewAlertMessage": {
		"en": "Auto extraction： Performed at 00:00 for data collected on the previous day",
		"hk": "自動入庫： 每日凌晨12點將前一天符合話題搜索條件之數據自動提取至編碼庫",
		"tw": "自動入庫： 每日凌晨12點將前一天符合話題搜索條件之數據自動提取至編碼庫",
		"cn": "自动入库： 每日凌晨12点将前一天符合话题搜索条件的数据自动提取至编码库"
	},
	"subjectListLabelAlert": {
		"en": "Add or categorize under Subject Setting.",
		"hk": "話題設定下可新增或選擇分類。",
		"tw": "話題設定下可新增或選擇分類。",
		"cn": "话题设定下可新增或选择分类。"
	},
	"subjectPoolingOverviewCountNumber": {
		"en": "Data volume",
		"hk": "總數據量",
		"tw": "總數據量",
		"cn": "总数据量"
	},
	"subjectPoolingOverviewIsPoolingCountNumber": {
		"en": "Extracted data",
		"tw": "編碼庫總量",
		"hk": "編碼庫總量",
		"cn": "编码库总量"
	},
	"subjectPoolingOverviewIsAllCountNumber": {
		"en": "Extracted data",
		"hk": "已入庫總量",
		"tw": "已入庫總量",
		"cn": "已入库总量"
	},
	"subjectPoolingOverviewIsCrementCountNumber": {
		"en": "New added data",
		"hk": "新增數據量",
		"tw": "新增數據量",
		"cn": "新增数据量"
	},
	"subjectPoolingOverviewIsDeletedCountNumber": {
		"en": "Recovery data",
		"hk": "回收庫總量",
		"tw": "回收庫總量",
		"cn": "回收库总量"
	},
	"subjectPoolingOverviewIsCodedCountNumber": {
		"en": "Coded data",
		"hk": "已編碼量",
		"tw": "已編碼量",
		"cn": "已编码量"
	},
	"subjectPoolingPoolTopics": {
		"en": "Extract threads",
		"hk": "提取主帖",
		"tw": "提取主帖",
		"cn": "提取主帖"
	},
	"subjectFroumPoolingPoolTopics": {
		"en": "Extract threads and replies",
		"hk": "提取主回帖",
		"tw": "提取主回帖",
		"cn": "提取主回帖"
	},
	"PoolTopics": {
		"en": "Extract threads",
		"hk": "提取主帖",
		"tw": "提取主帖",
		"cn": "提取主帖"
	},
	"ForumComment": {
		"en": "Extract threads and replies",
		"hk": "提取主回帖",
		"tw": "提取主回帖",
		"cn": "提取主回帖"
	},
	"subjectPoolingUpdateTopics": {
		"en": "Update threads",
		"hk": "更新主帖",
		"tw": "更新主帖",
		"cn": "更新主帖"
	},
	"UpdateTopics": {
		"en": "Update threads",
		"hk": "更新主帖",
		"tw": "更新主帖",
		"cn": "更新主帖"
	},
	"subjectPoolingPoolComments": {
		"en": "Extract replies",
		"hk": "提取回帖",
		"tw": "提取回帖",
		"cn": "提取回帖"
	},
	"PoolComments": {
		"en": "Extract replies",
		"hk": "提取回帖",
		"tw": "提取回帖",
		"cn": "提取回帖"
	},
	"subjectPoolingMachineCoding": {
		"en": "Machine Coding",
		"hk": "機器編碼",
		"tw": "機器編碼",
		"cn": "机器编码"
	},
	"MachineCoding": {
		"en": "Machine Coding",
		"hk": "機器編碼",
		"tw": "機器編碼",
		"cn": "机器编码"
	},
	"subjectPoolingExceed": {
		"en": "Data exceed the limit",
		"hk": "數據已超額",
		"tw": "數據已超額",
		"cn": "数据已超额"
	},
	"subjectPoolingSee": {
		"en": "Check",
		"hk": "查看",
		"tw": "查看",
		"cn": "查看"
	},
	"subjectPoolingOriginData": {
		"en": "Source",
		"hk": "源數據",
		"tw": "源數據",
		"cn": "数据源"
	},
	"subjectPoolingNotput": {
		"en": "Pending extraction",
		"hk": "未入庫",
		"tw": "未入庫",
		"cn": "未入库"
	},
	"subjectPoolingPutData": {
		"en": "Extract",
		"tw": "提取數據",
		"hk": "提取數據",
		"cn": "提取数据"
	},
	"subjectPoolingputting": {
		"en": "Extracting...",
		"hk": "提取中...",
		"tw": "提取中...",
		"cn": "提取中..."
	},
	"subjectPoolingCheck": {
		"en": "Click to check",
		"hk": "點擊查看",
		"tw": "點擊查看",
		"cn": "点击查看"
	},
	"subjectPoolingSampleSuccessAddTesting": {
		"en": "Added to the testing pool!",
		"hk": "成功加入測試庫！",
		"tw": "成功加入測試庫！",
		"cn": "成功加入测试库！"
	},
	"subjectPoolingSampleDeletTitle": {
		"en": "Are you sure to remove all the data from the pool？",
		"hk": "確定要清空本媒體編碼庫中的所有內容嗎？",
		"tw": "確定要清空本媒體編碼庫中的所有內容嗎？",
		"cn": "确定要清空本媒体编码库中的所有内容吗？"
	},
	"subjectPoolingSampleDeletcontent": {
		"en": "Those data will be stored in trash pool.  You can restore or delete it from the pool.",
		"tw": "這些內容會存放到回收站，可到回收站進行恢復或徹底刪除",
		"hk": "這些內容會存放到回收站，可到回收站進行恢復或徹底刪除",
		"cn": "这些内容会存放到回收站，可到回收站进行恢复或彻底删除"
	},
	"subjectPoolingSampleAddTestingTrigger": {
		"en": "Please enter the number, maxium of 300.",
		"hk": "請輸入數量，最大300筆",
		"tw": "請輸入數量，最大300筆",
		"cn": "请输入数量，最大300条"
	},
	"subjectPoolingInputKeyword": {
		"en": "Please enter the keyword",
		"hk": "請輸入關鍵詞",
		"tw": "請輸入關鍵詞",
		"cn": "请输入关键词"
	},
	"subjectPoolingSelectedList": {
		"en": "Selected list",
		"hk": "已選列表",
		"tw": "已選列表",
		"cn": "已选列表"
	},
	"subjectPoolingRemoveAll": {
		"en": "Remove all",
		"hk": "全部移除",
		"tw": "全部移除",
		"cn": "全部移除"
	},
	"subjectPoolingSampleAddTestingButtonText": {
		"en": "Randomly add to testing pool",
		"hk": "隨機導入到測試庫",
		"tw": "隨機導入到測試庫",
		"cn": "随机导入到测试库"
	},
	"subjectPoolingSampleuploadData": {
		"en": "Upload",
		"hk": "上載數據",
		"tw": "上載數據",
		"cn": "上传数据"
	},
	"onlyUploadExcel": {
		"en": "Can only upload Excel/CSV files oh!",
		"hk": "只能上傳 Excel/CSV 文件哦！",
		"tw": "只能上傳 Excel/CSV 文件哦！",
		"cn": "只能上传 Excel/CSV 文件哦！"
	},
	"onlyUploadJPG": {
		"en": "Can only upload JPG / PNG / PDF files oh!",
		"hk": "只能上載 JPG / PNG / PDF 文件哦！",
		"tw": "只能上載 JPG / PNG / PDF 文件哦！",
		"cn": "只能上传 JPG / PNG / PDF 文件哦！"
	},
	"uploadSuccess": {
		"en": "Upload success.",
		"hk": "上載成功。",
		"tw": "上載成功。",
		"cn": "上传成功。"
	},
	"uploadFailed": {
		"en": "Upload failed.",
		"hk": "上載失敗。",
		"tw": "上載失敗。",
		"cn": "上传失败。"
	},
	"fileUploadFaiel": {
		"en": "File upload failed. Please check if there is a complete content in {{fileName}}",
		"hk": "文件上載失敗。請檢查 {{fileName}} 中是否有填寫內容。",
		"tw": "文件上載失敗。請檢查 {{fileName}} 中是否有填寫內容。",
		"cn": "文件上传失败。请检查 {{fileName}} 中是否有填写内容。"
	},
	"downloadFile": {
		"en": "Download the file template",
		"hk": "下載文件模版",
		"tw": "下載文件模版",
		"cn": "下载文件模板"
	},
	"antUploadText": {
		"en": "Click or drag the file to this area",
		"hk": "點擊或將文件拖拽到此區域上載",
		"tw": "點擊或將文件拖拽到此區域上載",
		"cn": "点击或将文件拖拽到此区域上传"
	},
	"antUploadHint": {
		"en": "Only supports uploading CSV and Excel files",
		"hk": "僅支持上載CSV和Excel文件",
		"tw": "僅支持上載CSV和Excel文件",
		"cn": "仅支持上传CSV和Excel文件"
	},
	"antUploadHintJPG": {
		"en": "Only supports upload JPEG, PNG and PDF files",
		"hk": "僅支持上載JPEG、PNG和PDF文件",
		"tw": "僅支持上載JPEG、PNG和PDF文件",
		"cn": "仅支持上传JPEG、PNG和PDF文件"
	},
	"uploadExcel": {
		"en": "Upload CSV/Excel",
		"hk": "上載CSV/Excel",
		"tw": "上載CSV/Excel",
		"cn": "上传CSV/Excel"
	},
	"uploadJPG": {
		"en": "Upload Image/PDF",
		"tw": "上載圖片/PDF",
		"hk": "上載圖片/PDF",
		"cn": "上传图片/PDF"
	},
	"subjectPoolingRecycleRejectTitle": {
		"en": "Are you sure to remove all data from the trash pool？",
		"tw": "確定要清空回收站的所有內容嗎？",
		"hk": "確定要清空回收站的所有內容嗎？",
		"cn": "确定要清空回收站的所有内容吗？"
	},
	"subjectPoolingRecycleRejectContent": {
		"en": "Data can not be recovered after deleting from the trash pool.",
		"hk": "清空將無法再恢復這些內容",
		"tw": "清空將無法再恢復這些內容",
		"cn": "清空将无法再恢复这些内容"
	},
	"subjectPoolingAllRecover": {
		"en": "Restore all",
		"tw": "全部恢復",
		"hk": "全部恢復",
		"cn": "全部恢复"
	},
	"subjectPoolingAllRecoverModel": {
		"en": "Are you sure to restore the data to the sample pool?",
		"tw": "確定要恢復至編碼庫中嗎？",
		"hk": "確定要恢復至編碼庫中嗎？",
		"cn": "确定要恢复至编码库中吗？"
	},
	"subjectPoolingDestroySamples": {
		"en": "Clean trash pool",
		"tw": "清空回收站",
		"hk": "清空回收站",
		"cn": "清空回收站"
	},
	"subjectCategoryExceed": {
		"en": "Question number exceeded the limit",
		"tw": "題目數量已達上限",
		"hk": "題目數量已達上限",
		"cn": "题目数量已达上限"
	},
	"categoryMessagePleaseAddQuestion": {
		"en": "Please add a question",
		"tw": "請先添加題目",
		"hk": "請先添加題目",
		"cn": "请先添加题目"
	},
	"categoryCreateQuestion": {
		"en": "Create a question",
		"tw": "新建問題",
		"hk": "新建問題",
		"cn": "新建问题"
	},
	"categoryImportQuestion": {
		"en": "Pull Population Base Category",
		"tw": "同步總體庫類目",
		"hk": "同步總體庫類目",
		"cn": "同步总体库类目"
	},
	"categoryQuestionBank": {
		"en": "Question library",
		"tw": "題庫",
		"hk": "題庫",
		"cn": "题库"
	},
	"categoryPreview": {
		"en": "Preview",
		"tw": "預覽",
		"hk": "預覽",
		"cn": "预览"
	},
	"categoryOption": {
		"en": "Option",
		"tw": "選項",
		"hk": "選項",
		"cn": "选项"
	},
	"categoryQuestionTitle": {
		"en": "Question",
		"tw": "題目",
		"hk": "題目",
		"cn": "题目"
	},
	"categoryQuestionTitleInputPlaceHolder": {
		"en": "Required question",
		"tw": "題目，必填項",
		"hk": "題目，必填項",
		"cn": "题目，必填项"
	},
	"categoryDescription": {
		"en": "Remark",
		"tw": "備註",
		"hk": "備註",
		"cn": "备注"
	},
	"categoryDescriptionInputPlaceHolder": {
		"en": "Optional",
		"tw": "可選填項",
		"hk": "可選填項",
		"cn": "可选填项"
	},
	"categoryQuestionType": {
		"en": "Question type",
		"tw": "題型",
		"hk": "題型",
		"cn": "题型"
	},
	"categoryRadio": {
		"en": "Single selection",
		"tw": "單選題",
		"hk": "單選題",
		"cn": "单选题"
	},
	"categoryCheckBox": {
		"en": "Multiple selection",
		"tw": "多選題",
		"hk": "多選題",
		"cn": "多选题"
	},
	"categoryIsRequired": {
		"en": "Required",
		"tw": "必填",
		"hk": "必填",
		"cn": "必填"
	},
	"categoryCreateOption": {
		"en": "Create option",
		"tw": "新建選項",
		"hk": "新建選項",
		"cn": "新建选项"
	},
	"categoryOutline": {
		"en": "Categorization outline",
		"tw": "類目大綱",
		"hk": "類目大綱",
		"cn": "类目大纲"
	},
	"categoryOutlineMuted": {
		"en": "Drag to sort",
		"tw": "拖動題目可排序",
		"hk": "拖動題目可排序",
		"cn": "拖动标题可排序"
	},
	"categoryEditKeyword": {
		"en": "Edit keywords",
		"hk": "編輯關鍵字",
		"tw": "編輯關鍵字",
		"cn": "编辑关键字"
	},
	"categoryOpenOption": {
		"en": "Open option",
		"tw": "開放",
		"hk": "開放",
		"cn": "开放"
	},
	"categoryIsOpen": {
		"en": "Open item",
		"tw": "開放項",
		"hk": "開放項",
		"cn": "开放项"
	},
	"categoryDeleteOption": {
		"en": "Delete option",
		"tw": "移除選項",
		"hk": "移除選項",
		"cn": "移除选项"
	},
	"categoryAlias": {
		"en": "Alias",
		"tw": "別名",
		"hk": "別名",
		"cn": "别名"
	},
	"categoryPopoverAlias": {
		"en": "This option alias",
		"tw": "本選項別名",
		"hk": "本選項別名",
		"cn": "本选项别名"
	},
	"categoryPopoverKeyword": {
		"en": "This option keyword",
		"tw": "本選項關鍵字",
		"hk": "本選項關鍵字",
		"cn": "本选项关键字"
	},
	"categoryRevoke": {
		"en": "Undo",
		"tw": "撤销",
		"hk": "撤销",
		"cn": "撤销"
	},
	"categoryRevokeSucces": {
		"en": "Undo success",
		"tw": "撤销成功",
		"hk": "撤销成功",
		"cn": "撤销成功"
	},
	"categoryPopoverTitle": {
		"en": "Select this option to display the following question",
		"tw": "選擇本項顯示以下題目",
		"hk": "選擇本項顯示以下題目",
		"cn": "选择本项显示以下题目"
	},
	"categoryShow": {
		"en": "Display",
		"tw": "顯示",
		"hk": "顯示",
		"cn": "显示"
	},
	"categorySetttingLogical": {
		"en": "Setup logic",
		"tw": "設置邏輯",
		"hk": "設置邏輯",
		"cn": "设置逻辑"
	},
	"categoryCollection": {
		"en": "Favorite",
		"hk": "收藏",
		"tw": "收藏",
		"cn": "收藏"
	},
	"categoryCollectioned": {
		"en": "Save favorite",
		"tw": "已收藏",
		"hk": "已收藏",
		"cn": "已收藏"
	},
	"categoryNotQuestionText": {
		"en": "Click above button to create a question",
		"tw": "點擊上方按鈕新建問題",
		"hk": "點擊上方按鈕新建問題",
		"cn": "点击上方按钮新建问题"
	},
	"categoryQuestionBankNot": {
		"en": "No favorite category",
		"tw": "暫無收藏类目",
		"hk": "暫無收藏类目",
		"cn": "暂无收藏类目"
	},
	"categorySetttingLogicalWhen": {
		"en": "When user select the following option",
		"tw": "當用戶選擇以下選項：",
		"hk": "當用戶選擇以下選項：",
		"cn": "当用户选择以下选项："
	},
	"categorySetttingLogicalShow": {
		"en": "Display the following question",
		"tw": "則顯示以下題目：",
		"hk": "則顯示以下題目：",
		"cn": "则显示以下题目："
	},
	"isRequiredMessageText": {
		"en": "Answer required",
		"tw": "號題是必填題目！請回答完整！",
		"hk": "號題是必填題目！請回答完整！",
		"cn": "号题是必填题目！请回答完整！"
	},
	"subjectSettingConditionExceed": {
		"en": "Alert conditions reached the limit",
		"tw": "預警條件已達上限",
		"hk": "預警條件已達上限",
		"cn": "预警条件已达上限"
	},
	"subjectSettingRecipientExceed": {
		"en": "Receipients reached the limit",
		"tw": "接收者已達上限",
		"hk": "接收者已達上限",
		"cn": "接收者已达上限"
	},
	"subjectSettingRecipientTip": {
		"en": "·{{total}} receipients can be / were added {{exist}}·",
		"tw": "可添加 {{total}} 個接收者/已添加 {{exist}} 個",
		"hk": "可添加 {{total}} 個接收者/已添加 {{exist}} 個",
		"cn": "可添加 {{total}} 个接收者/已添加 {{exist}} 个"
	},
	"subjectSettingGeneral": {
		"en": "General setting",
		"tw": "通用設定",
		"hk": "通用設定",
		"cn": "通用设定"
	},
	"subjectSettingMedia": {
		"en": "Media Setting",
		"tw": "媒體設定",
		"hk": "媒體設定",
		"cn": "媒体设定"
	},
	"subjectSettingKeysForAllMedia": {
		"en": "All media type common keywords",
		"tw": "全媒體公用關鍵詞",
		"hk": "全媒體公用關鍵詞",
		"cn": "全媒体公用关键词"
	},
	"subjectAllMediaKeysAndNot": {
		"en": "All media type common keywords and excluded words",
		"tw": "全媒體公用關鍵詞及排除詞",
		"hk": "全媒體公用關鍵詞及排除詞",
		"cn": "全媒体公用关键词及排除词"
	},
	"subjectSettingNotForAllMedia": {
		"en": "All media type common excluded words",
		"tw": "全媒體公用排除詞",
		"hk": "全媒體公用排除詞",
		"cn": "全媒体公用排除词"
	},
	"subjectSettingKeysForPrivateMedia": {
		"en": "Keywords for specific media",
		"tw": "本媒體特有關鍵詞",
		"hk": "本媒體特有關鍵詞",
		"cn": "本媒体特有关键词"
	},
	"subjectPrivateKeysAndNot": {
		"en": "Keywords and excluded words for specific media",
		"tw": "本媒體特有關鍵詞及排除詞",
		"hk": "本媒體特有關鍵詞及排除詞",
		"cn": "本媒体特有关键词及排除词"
	},
	"subjectSettingNotForPrivateMedia": {
		"en": "Excluded words for specific media",
		"tw": "本媒體特有排除詞",
		"hk": "本媒體特有排除詞",
		"cn": "本媒体特有排除词"
	},
	"subjectSettingLabels": {
		"en": "Subject Category",
		"tw": "分類",
		"hk": "分類",
		"cn": "分类"
	},
	"subjectSettingInputOrChooseLabel": {
		"en": "Create or selct subject category",
		"tw": "輸入或選擇分類",
		"hk": "輸入或選擇分類",
		"cn": "输入或选择分类"
	},
	"subjectSettingAddMediaType": {
		"en": "Add media type",
		"hk": "添加媒體類型",
		"tw": "添加媒體類型",
		"cn": "添加媒体类型"
	},
	"subjectSettingConfirmToDeleteUser": {
		"en": "Are you sure to remove this member?",
		"tw": "確認要刪除此用戶？",
		"hk": "確認要刪除此用戶？",
		"cn": "确认要删除此用户？"
	},
	"subjectSettingConfirmToDeleteUserDescription": {
		"en": "After removal, this member cannot check this subject anymore.",
		"tw": "刪除后，此用戶將無法看到此話題的相關內容。",
		"hk": "刪除后，此用戶將無法看到此話題的相關內容。",
		"cn": "删除后，此用户将无法看到此话题的相关内容。"
	},
	"subjectSettingUserRequired": {
		"en": "Please select one member at least",
		"tw": "請至少選擇一個用戶",
		"hk": "請至少選擇一個用戶",
		"cn": "请至少选择一个用户"
	},
	"subjectSettingChooseGroup": {
		"en": "Please select the member group",
		"tw": "請選擇群組",
		"hk": "請選擇群組",
		"cn": "请选择群组"
	},
	"subjectSettingChooseUser": {
		"en": "Please select the member",
		"tw": "請選擇用戶",
		"hk": "請選擇用戶",
		"cn": "请选择用户"
	},
	"subjectSettingAddToSubject": {
		"en": "Add to this subject",
		"hk": "添加到本話題",
		"tw": "添加到本話題",
		"cn": "添加到本话题"
	},
	"subjectSettingThisIsYou": {
		"en": "You",
		"hk": "這是你",
		"tw": "這是你",
		"cn": "这是你"
	},
	"subjectAlertTesting": {
		"en": "The buzz trend for the past 24 hours",
		"tw": "所設條件過去24小時趨勢",
		"hk": "所設條件過去24小時趨勢",
		"cn": "所设条件过去24小时趋势"
	},
	"subjectAlertConditionRequired": {
		"en": "At least one alert condition is required",
		"tw": "至少需要一個預警條件",
		"hk": "至少需要一個預警條件",
		"cn": "至少需要一个预警条件"
	},
	"subjectAlertReceipentRequired": {
		"en": "At least one receipient is required",
		"tw": "至少需要一個聯繫人",
		"hk": "至少需要一個聯繫人",
		"cn": "至少需要一个联系人"
	},
	"subjectAlertConfirmActive": {
		"en": "Activate Alert or not?",
		"hk": "是否開啟預警",
		"tw": "是否開啟預警",
		"cn": "是否开启预警"
	},
	"subjectAlertOpen": {
		"en": "Activate",
		"tw": "開",
		"hk": "開",
		"cn": "开"
	},
	"subjectAlertClose": {
		"en": "Close",
		"tw": "關",
		"hk": "關",
		"cn": "关"
	},
	"subjectAlertConditionSetting": {
		"en": "Condition setting",
		"hk": "條件設定",
		"tw": "條件設定",
		"cn": "条件设定"
	},
	"subjectAlertAddCondition": {
		"en": "Add alert condition",
		"tw": "添加預警條件",
		"hk": "添加預警條件",
		"cn": "添加预警条件"
	},
	"subjectAlertNotificationMode": {
		"en": "Notification mode",
		"tw": "通知模式",
		"hk": "通知模式",
		"cn": "通知模式"
	},
	"subjectAlertInfoShouldComplate": {
		"en": "Please enter complete information",
		"tw": "請填寫完整信息",
		"hk": "請填寫完整信息",
		"cn": "请填写完整信息"
	},
	"subjectAlertEmail": {
		"en": "E-mail",
		"tw": "電郵地址",
		"hk": "電郵地址",
		"cn": "邮件地址"
	},
	"subjectAlertMonitorValue": {
		"en": "Monitoring value",
		"tw": "監測數值",
		"hk": "監測數值",
		"cn": "监测数值"
	},
	"subjectAlertOperator": {
		"en": "Monitoring values",
		"tw": "統計方法",
		"hk": "統計方法",
		"cn": "统计方法"
	},
	"subjectAlertWechatGh": {
		"en": "WeChat OA",
		"tw": "微信公眾號",
		"hk": "微信公眾號",
		"cn": "微信公众号"
	},
	"subjectAlertWechatScan": {
		"en": "Please use WeChat to scan the QR code to become a receipient.",
		"tw": "掃描二維碼加入預警通知名單。",
		"hk": "掃描二維碼加入預警通知名單。",
		"cn": "扫描二维码加入预警通知名单。"
	},
	"subjectAlertWechatNot": {
		"en": "Fail to decode the QR code, please click again.",
		"tw": "二維碼獲取失敗，點擊重新獲取。",
		"hk": "二維碼獲取失敗，點擊重新獲取。",
		"cn": "二维码获取失败，点击重新获取。"
	},
	"subjectAlertThresholdRequired": {
		"en": "Please enter the threshold",
		"tw": "請填寫閾值",
		"hk": "請填寫閾值",
		"cn": "请填写阈值"
	},
	"subjectWorkloadSampleTotal": {
		"en": "Coding Pool Volume",
		"tw": "編碼庫總量",
		"hk": "編碼庫總量",
		"cn": "编码库总量"
	},
	"subjectWorkloadLeft": {
		"en": "Articles remained",
		"tw": "剩餘條數",
		"hk": "剩餘條數",
		"cn": "剩余条数"
	},
	"subjectWorkloadCoded": {
		"en": "Coded",
		"tw": "已編碼",
		"hk": "已編碼",
		"cn": "已编码"
	},
	"subjectWorkloadAvgTime": {
		"en": "Average time used",
		"tw": "平均用時",
		"hk": "平均用時",
		"cn": "平均用时"
	},
	"subjectWorkloadUserName": {
		"en": "Coder Name",
		"tw": "編碼員",
		"hk": "編碼員",
		"cn": "编码员"
	},
	"subjectWorkloadCodedCount": {
		"en": "Posts counted",
		"tw": "帖子數量",
		"hk": "帖子數量",
		"cn": "帖子数量"
	},
	"subjectWorkloadWordCount": {
		"en": "Words counted",
		"tw": "字符數量",
		"hk": "字符數量",
		"cn": "字符数量"
	},
	"subjectWorkloadCodeTime": {
		"en": "Coding Time",
		"tw": "編碼所用時間",
		"hk": "編碼所用時間",
		"cn": "编码所用时间"
	},
	"subjectWorkloadCodeSpeed": {
		"en": "Coding Speed",
		"tw": "編碼速度（時間/帖數）",
		"hk": "編碼速度（時間/帖數）",
		"cn": "编码速度（时间/帖数）"
	},
	"subjectStatisticChooseQuestion": {
		"en": "Please select a question",
		"tw": "請選擇題目",
		"hk": "請選擇題目",
		"cn": "请选择栏目"
	},
	"subjectQualityControlChooseCategory": {
		"en": "Please select a column",
		"tw": "選擇欄目",
		"hk": "選擇欄目",
		"cn": "选择栏目"
	},
	"subjectQualityControlChooseCategoryError": {
		"en": "Please select one column at least",
		"tw": "至少選擇一個欄目",
		"hk": "至少選擇一個欄目",
		"cn": "至少选择一个栏目"
	},
	"subjectQualityControlChooseCategoryOperationsAdd": {
		"en": "Add column",
		"tw": "添加選中欄目",
		"hk": "添加選中欄目",
		"cn": "添加选中栏目"
	},
	"subjectQualityControlChooseCategoryOperationsRemove": {
		"en": "Delete column",
		"tw": "移除選中欄目",
		"hk": "移除選中欄目",
		"cn": "移除选中栏目"
	},
	"subjectQualityControlCategoryControl": {
		"en": "Column control",
		"hk": "欄目控制",
		"tw": "欄目控制",
		"cn": "栏目控制"
	},
	"subjectCodingQuestionRequired": {
		"en": "Mandatory questions, please select the option",
		"tw": "是必填題目！請回答完整！",
		"hk": "是必填題目！請回答完整！",
		"cn": "是必填题目！请回答完整！"
	},
	"subjectCodingBack": {
		"en": "Review",
		"tw": "回看",
		"hk": "回看",
		"cn": "回看"
	},
	"subjectCodingNoStart": {
		"en": "No coding task",
		"tw": "編碼工作尚未開始或已完成",
		"hk": "編碼工作尚未開始或已完成",
		"cn": "编码工作尚未开始或已完成"
	},
	"subjectCodingFeedbackContent": {
		"en": "Please enter your message",
		"tw": "請輸入留言內容",
		"hk": "請輸入留言內容",
		"cn": "请输入留言内容"
	},
	"SubjectTesting": {
		"en": "Coding testing",
		"tw": "編碼測試",
		"hk": "編碼測試",
		"cn": "编码测试"
	},
	"InterCoderReliability": {
		"en": "Reliability",
		"tw": "信度計算",
		"hk": "信度計算",
		"cn": "信度计算"
	},
	"CompositeReliability": {
		"en": "Composite Reliability",
		"tw": "複合信度",
		"hk": "複合信度",
		"cn": "复合信度"
	},
	"reliability": {
		"en": "Calculation",
		"tw": "計算",
		"hk": "計算",
		"cn": "计算"
	},
	"SubjectTestingFollowing": {
		"en": "Coding tracking",
		"tw": "編碼跟蹤",
		"hk": "編碼跟蹤",
		"cn": "编码跟踪"
	},
	"prevTestingMedia": {
		"en": "Previous",
		"tw": "上一篇",
		"hk": "上一篇",
		"cn": "上一篇"
	},
	"nextTestingMedia": {
		"en": "Next",
		"tw": "下一篇",
		"hk": "下一篇",
		"cn": "下一篇"
	},
	"TestingMedias": {
		"en": "List",
		"hk": "列表",
		"tw": "列表",
		"cn": "列表"
	},
	"TestingMediaNotText": {
		"en": "No coding testing can be tracked",
		"tw": "暫無測試編碼可跟蹤",
		"hk": "暫無測試編碼可跟蹤",
		"cn": "暂无测试编码可跟踪"
	},
	"codingMediasNotText": {
		"en": "No coding data",
		"tw": "還沒有任何編碼內容",
		"hk": "還沒有任何編碼內容",
		"cn": "还没有任何编码内容"
	},
	"testingSelectMedia": {
		"en": "Questions filter",
		"hk": "篩選類目",
		"tw": "篩選類目",
		"cn": "筛选类目"
	},
	"InterCoderReliabilityMessageMaxText": {
		"en": "Maximum of 4 coders",
		"tw": "最多只能添加4名編碼員",
		"hk": "最多只能添加4名編碼員",
		"cn": "最多只能添加4名编码员"
	},
	"InterCoderReliabilityMessageMinText": {
		"en": "At least 2 coders to be  calculated",
		"tw": "至少需要選擇2名編碼員，才能進行計算",
		"hk": "至少需要選擇2名編碼員，才能進行計算",
		"cn": "至少需要选择2名编码员，才能进行计算"
	},
	"InterCoderReliabilitySelectPlaceholder": {
		"en": "Please select coders",
		"tw": "請選擇編碼員",
		"hk": "請選擇編碼員",
		"cn": "请选择编码员"
	},
	"InterCoderReliabilityAlertdescriptionText": {
		"en": "Please select 2 to 4 coders to calculate reliability",
		"tw": "請選擇2~4名編碼員進行信度計算",
		"hk": "請選擇2~4名編碼員進行信度計算",
		"cn": "请选择2~4名编码员进行信度计算"
	},
	"QuestionCanNotCoding": {
		"en": "Coding not available",
		"hk": "暫無法進行分析",
		"tw": "暫無法進行分析",
		"cn": "暂无法进行分析"
	},
	"GetOutToCreateCategory": {
		"en": "Please create questions in \"Categorization\"",
		"hk": "請前往類目管理創建題目",
		"tw": "請前往類目管理創建題目",
		"cn": "请前往类目管理创建题目"
	},
	"subjectStatistic": {
		"en": "Data Management",
		"hk": "數據統計",
		"tw": "數據統計",
		"cn": "数据管理"
	},
	"subjectWorkload": {
		"en": "Coder Performance",
		"hk": "實驗效率",
		"tw": "實驗效率",
		"cn": "编码绩效"
	},
	"subjectAnalysis": {
		"en": "Analysis",
		"tw": "統計圖表",
		"hk": "統計圖表",
		"cn": "分析"
	},
	"meSettingPasswordInvalid": {
		"en": "Passwords were not matched",
		"hk": "兩次輸入密碼不一致",
		"tw": "兩次輸入密碼不一致",
		"cn": "两次输入密码不一致"
	},
	"meSettingChangePassword": {
		"en": "Change your password",
		"hk": "修改密碼",
		"tw": "修改密碼",
		"cn": "修改密码"
	},
	"meSettingInputPassword": {
		"en": "Please enter password",
		"tw": "請輸入密碼",
		"hk": "請輸入密碼",
		"cn": "请输入密码"
	},
	"meSettingInputPasswordAgain": {
		"en": "Please enter password again",
		"tw": "請再次輸入密碼",
		"hk": "請再次輸入密碼",
		"cn": "请再次输入密码"
	},
	"meSettingChangeLanguage": {
		"en": "Language",
		"tw": "系統語言設定",
		"hk": "系統語言設定",
		"cn": "系统语言设定"
	},
	"deleteSubject": {
		"en": "Delete",
		"hk": "刪除本話題",
		"tw": "刪除本話題",
		"cn": "删除本话题"
	},
	"deleteSubjectModelTitle": {
		"en": "Are you sure to delete this subject?",
		"tw": "您確定要刪除此話題嗎？",
		"hk": "您確定要刪除此話題嗎？",
		"cn": "您确定要删除此话题吗？"
	},
	"deleteSubjectLabelModelTitle": {
		"en": "Are you sure to delete this category?",
		"tw": "您確定要刪除此分類嗎？",
		"hk": "您確定要刪除此分類嗎？",
		"cn": "您确定要删除此分类吗？"
	},
	"deleteSubjectModelContent": {
		"en": "You cannot retore it after deletion",
		"tw": "刪除後無法恢復",
		"hk": "刪除後無法恢復",
		"cn": "删除后无法恢复"
	},
	"alertConditions": {
		"en": "Monitoring Conditions",
		"hk": "監測條件",
		"tw": "監測條件",
		"cn": "监测条件"
	},
	"alertAllMediaTypes": {
		"en": "All media",
		"tw": "全部媒體",
		"hk": "全部媒體",
		"cn": "全部媒体"
	},
	"alertNoConditions": {
		"en": "You have yet set the alert condition. Please do the setting first.",
		"tw": "暫無預警條件，請前往設置添加",
		"hk": "暫無預警條件，請前往設置添加",
		"cn": "暂无预警条件，请前往设置添加"
	},
	"alertListTitle": {
		"en": "Total alerts： {{count}}",
		"tw": "總共有 {{count}} 個預警監測",
		"hk": "總共有 {{count}} 個預警監測",
		"cn": "总共有 {{count}} 个预警监测"
	},
	"createAlert": {
		"en": "Create alert",
		"tw": "創建預警",
		"hk": "創建預警",
		"cn": "创建预警"
	},
	"alertGroup": {
		"en": "Alert Categories",
		"hk": "預警分類",
		"tw": "預警分類",
		"cn": "预警分类"
	},
	"alertCreateStepOne": {
		"en": "1. Enter the alert name",
		"tw": "第一步：填寫预警名稱",
		"hk": "第一步：填寫预警名稱",
		"cn": "第一步：填写预警名称"
	},
	"alertNameRequired": {
		"en": "Alert name is required",
		"tw": "预警名稱為必填",
		"hk": "预警名稱為必填",
		"cn": "预警名称为必填"
	},
	"commonAlertName": {
		"en": "Alert name",
		"hk": "预警名稱",
		"tw": "预警名稱",
		"cn": "预警名称"
	},
	"alertRecord": {
		"en": "Alert log",
		"hk": "預警記錄",
		"tw": "預警記錄",
		"cn": "预警记录"
	},
	"returnAlertsList": {
		"en": "Return to Alert list",
		"hk": "返回預警列表",
		"tw": "返回預警列表",
		"cn": "返回预警列表"
	},
	"fetchQplaceholder": {
		"en": "Please enter keywords",
		"hk": "輸入查詢關鍵字，回車查詢",
		"tw": "輸入查詢關鍵字，回車查詢",
		"cn": "输入查询关键字，回车查询"
	},
	"fetchNotFoundContent": {
		"en": "Press \"Enter\" to search",
		"hk": "輕敲回車查詢",
		"tw": "輕敲回車查詢",
		"cn": "轻敲回车查询"
	},
	"alertSentimentData": {
		"en": "Count",
		"hk": "筆",
		"tw": "筆",
		"cn": "条"
	},
	"analysisChooseSubject": {
		"en": "Please choose a subject",
		"hk": "請選擇話題",
		"tw": "請選擇話題",
		"cn": "请选择话题"
	},
	"alertIsTriggerNumber": {
		"en": "times",
		"hk": "次",
		"tw": "次",
		"cn": "次"
	},
	"alertIsTrigger": {
		"en": "Already triggered",
		"hk": "已觸發",
		"tw": "已觸發",
		"cn": "已触发"
	},
	"alertNoTrigger": {
		"en": "Not triggered",
		"hk": "未觸發",
		"tw": "未觸發",
		"cn": "未触发"
	},
	"alert24HoursIsTrigger": {
		"en": "Today has been triggered",
		"hk": "今日已被觸發",
		"tw": "今日已被觸發",
		"cn": "今日已被触发"
	},
	"alert24HoursNoTrigger": {
		"en": "Today is not triggered",
		"hk": "今日未被觸發",
		"tw": "今日未被觸發",
		"cn": "今日未被触发"
	},
	"alertLastMonitorTime": {
		"en": "Last trigger monitoring time",
		"hk": "上次觸發監測時間",
		"tw": "上次觸發監測時間",
		"cn": "上次触发监测时间"
	},
	"count": {
		"en": "count",
		"tw": "計數",
		"hk": "計數",
		"cn": "计数"
	},
	"sum": {
		"en": "sum",
		"hk": "求和",
		"tw": "求和",
		"cn": "求和"
	},
	"avg": {
		"en": "avg",
		"hk": "平均數",
		"tw": "平均數",
		"cn": "平均数"
	},
	"average": {
		"en": "average",
		"hk": "平均值",
		"tw": "平均值",
		"cn": "平均值"
	},
	"max": {
		"en": "max",
		"hk": "最大值",
		"tw": "最大值",
		"cn": "最大值"
	},
	"min": {
		"en": "min",
		"hk": "最小值",
		"tw": "最小值",
		"cn": "最小值"
	},
	"analysisModifyName": {
		"en": "Modify name",
		"tw": "修改名稱",
		"hk": "修改名稱",
		"cn": "修改名称"
	},
	"analysisDimension": {
		"en": "Dimension",
		"tw": "維度",
		"hk": "維度",
		"cn": "维度"
	},
	"analysisValue": {
		"en": "Value",
		"tw": "數值",
		"hk": "數值",
		"cn": "数值"
	},
	"AlertListExceed": {
		"en": "Alerts reached the limit",
		"tw": "預警數量已達上限",
		"hk": "預警數量已達上限",
		"cn": "预警数量已达上限"
	},
	"blog": {
		"en": "Blog",
		"tw": "部落格",
		"hk": "博客",
		"cn": "博客"
	},
	"video": {
		"en": "Video",
		"tw": "視頻",
		"hk": "視頻",
		"cn": "视频"
	},
	"macautalk": {
		"en": "MacauTalk",
		"tw": "澳門講場",
		"hk": "澳門講場",
		"cn": "澳门讲场"
	},
	"news": {
		"en": "News",
		"tw": "新聞",
		"hk": "新聞",
		"cn": "新闻"
	},
	"instagram": {
		"en": "Instagram",
		"tw": "Instagram",
		"hk": "Instagram",
		"cn": "Instagram"
	},
	"print": {
		"en": "Print",
		"tw": "印刷媒體",
		"hk": "印刷媒體",
		"cn": "印刷媒体"
	},
	"youtube": {
		"en": "YouTube",
		"tw": "YouTube",
		"hk": "YouTube",
		"cn": "YouTube"
	},
	"pixnet": {
		"en": "Pixnet",
		"tw": "痞客邦",
		"hk": "痞客邦",
		"cn": "痞客邦"
	},
	"_offlineNews": {
		"en": "Offline News",
		"tw": "本地數據",
		"hk": "本地數據",
		"cn": "本地数据"
	},
	"weibo": {
		"en": "Weibo",
		"hk": "微博",
		"tw": "微博",
		"cn": "微博"
	},
	"forum": {
		"en": "Forum",
		"hk": "論壇",
		"tw": "論壇",
		"cn": "论坛"
	},
	"forumComment": {
		"en": "Forum",
		"tw": "論壇",
		"hk": "論壇",
		"cn": "论坛"
	},
	"facebook": {
		"en": "Facebook",
		"tw": "Facebook",
		"hk": "Facebook",
		"cn": "Facebook"
	},
	"twitter": {
		"en": "Twitter",
		"tw": "Twitter",
		"hk": "Twitter",
		"cn": "Twitter"
	},
	"wechat": {
		"en": "Wechat",
		"tw": "微信",
		"hk": "微信",
		"cn": "微信"
	},
	"page": {
		"en": "Page",
		"tw": "專頁",
		"hk": "專頁",
		"cn": "专页"
	},
	"goods": {
		"en": "Goods",
		"tw": "商品",
		"hk": "商品",
		"cn": "商品"
	},
	"filterTake": {
		"en": "Front",
		"tw": "前",
		"hk": "前",
		"cn": "前"
	},
	"filterTakerRight": {
		"en": "Back",
		"tw": "後",
		"hk": "後",
		"cn": "后"
	},
	"filterCount": {
		"en": "Count",
		"tw": "條",
		"hk": "條",
		"cn": "条"
	},
	"subline": {
		"en": "Auxiliary line",
		"tw": "輔助线",
		"hk": "輔助线",
		"cn": "辅助线"
	},
	"addSubline": {
		"en": "Add Auxiliary line",
		"tw": "添加輔助線",
		"hk": "添加輔助線",
		"cn": "添加辅助线"
	},
	"clickAdd": {
		"en": "Click here to add",
		"tw": "點此添加",
		"hk": "點此添加",
		"cn": "点此添加"
	},
	"noSublineText": {
		"en": "You have not added auxiliary line",
		"tw": "您還未添加座標輔助線，",
		"hk": "您還未添加座標輔助線，",
		"cn": "您还未添加坐标辅助线，"
	},
	"fixedValue": {
		"en": "Fixed Value",
		"hk": "固定值",
		"tw": "固定值",
		"cn": "固定值"
	},
	"calculateValue": {
		"en": "Calculate Value",
		"tw": "計算值",
		"hk": "計算值",
		"cn": "计算值"
	},
	"chartType": {
		"en": "Chart Type",
		"tw": "圖表類型",
		"hk": "圖表類型",
		"cn": "图表类型"
	},
	"tableChart": {
		"en": "Table",
		"tw": "表格",
		"hk": "表格",
		"cn": "表格"
	},
	"footerInfo1": {
		"en": "This file was automatically generated by the eRS web mining system. The copyrights of the original contents are owned by relevant media respectively.",
		"hk": "本檔案由網絡挖掘系統自動生成，有關原始內容之版權屬相關媒體所有",
		"tw": "本檔案由網絡挖掘系統自動生成，有關原始內容之版權屬相關媒體所有",
		"cn": "本档案由网络挖掘系统自动生成，有关原始内容的版权属相关媒体所有"
	},
	"footerInfo2": {
		"en": "We do not guarantee its authenticity, accuracy and reliability.",
		"hk": "本司不保證其真實性、準確性和可靠性。",
		"tw": "本司不保證其真實性、準確性和可靠性。",
		"cn": "本司不保证其真实性、准确性和可靠性。"
	},
	"companyErs": {
		"en": "eRS Information Technology LTD.",
		"tw": "易研信息科技有限公司",
		"hk": "易研信息科技有限公司",
		"cn": "易研信息科技有限公司"
	},
	"companyBoyi": {
		"en": "Zhuhai Hengqin BoYi Data Technology Co. Ltd.",
		"hk": "珠海橫琴博易數據技術有限公司",
		"tw": "珠海橫琴博易數據技術有限公司",
		"cn": "珠海横琴博易数据技术有限公司"
	},
	"companyUmaxdata": {
		"en": "uMax Data Technology Co. Ltd.",
		"tw": "源大數據科技有限公司",
		"hk": "源大數據科技有限公司",
		"cn": "源大数据科技有限公司"
	},
	"companyErsShort": {
		"en": "eRS",
		"tw": "易研信息科技",
		"hk": "易研信息科技",
		"cn": "易研信息科技"
	},
	"companyBoyiShort": {
		"en": "BoYi Data",
		"tw": "博易數據",
		"hk": "博易數據",
		"cn": "博易数据"
	},
	"companyUmaxdataShort": {
		"en": "uMax Data",
		"tw": "源大數據",
		"hk": "源大數據",
		"cn": "源大数据"
	},
	"id": {
		"en": "Number",
		"tw": "數量",
		"hk": "數量",
		"cn": "数量"
	},
	"subject": {
		"en": "Subject",
		"hk": "話題",
		"tw": "話題",
		"cn": "话题"
	},
	"mediaType": {
		"en": "Media Type",
		"tw": "媒體",
		"hk": "媒體",
		"cn": "媒体"
	},
	"title": {
		"en": "Title",
		"tw": "標題",
		"hk": "標題",
		"cn": "标题"
	},
	"content": {
		"en": "Content",
		"tw": "正文",
		"hk": "正文",
		"cn": "正文"
	},
	"date": {
		"en": "Date",
		"tw": "日期",
		"hk": "日期",
		"cn": "日期"
	},
	"from": {
		"en": "From",
		"hk": "來源",
		"tw": "來源",
		"cn": "来源"
	},
	"in": {
		"en": "Section",
		"tw": "版块",
		"hk": "版块",
		"cn": "版塊"
	},
	"by": {
		"en": "Author",
		"hk": "作者",
		"tw": "作者",
		"cn": "作者"
	},
	"words": {
		"en": "Word Count",
		"tw": "字數",
		"hk": "字數",
		"cn": "字数"
	},
	"hits": {
		"en": "Views",
		"tw": "閱讀數",
		"hk": "閱讀數",
		"cn": "阅读数"
	},
	"comments": {
		"en": "Comments",
		"tw": "評論數",
		"hk": "評論數",
		"cn": "评论数"
	},
	"likes": {
		"en": "Likes",
		"hk": "讚好數",
		"tw": "讚好數",
		"cn": "点赞数"
	},
	"shares": {
		"en": "Shares",
		"tw": "分享數",
		"hk": "分享數",
		"cn": "分享数"
	},
	"hotvalue": {
		"en": "Hot value",
		"tw": "熱度值",
		"hk": "熱度值",
		"cn": "热度值"
	},
	"isCoded": {
		"en": "Coding？",
		"tw": "人工編碼",
		"hk": "人工編碼",
		"cn": "人工编码"
	},
	"isMachineCoded": {
		"en": "Machine Coding？",
		"tw": "機器編碼",
		"hk": "機器編碼",
		"cn": "机器编码"
	},
	"codedBy": {
		"en": "Coder",
		"hk": "編碼員",
		"tw": "編碼員",
		"cn": "编码员"
	},
	"codedAt": {
		"en": "Coding time",
		"tw": "編碼時間",
		"hk": "編碼時間",
		"cn": "编码时间"
	},
	"readedAt": {
		"en": "Viewing time",
		"tw": "閱覽時間",
		"hk": "閱覽時間",
		"cn": "阅览时间"
	},
	"position": {
		"en": "Level of replies",
		"tw": "回覆樓層數",
		"hk": "回覆樓層數",
		"cn": "回复楼层数"
	},
	"planningTasks": {
		"en": "Planning",
		"tw": "計劃任務",
		"hk": "計劃任務",
		"cn": "计划任务"
	},
	"executeTasks": {
		"en": "Implementing",
		"tw": "執行任務",
		"hk": "執行任務",
		"cn": "执行任务"
	},
	"Monday": {
		"en": "Monday",
		"hk": "週一",
		"tw": "週一",
		"cn": "周一"
	},
	"Tuesday": {
		"en": "Tuesday",
		"tw": "週二",
		"hk": "週二",
		"cn": "周二"
	},
	"Wednesday": {
		"en": "Wednesday",
		"hk": "週三",
		"tw": "週三",
		"cn": "周三"
	},
	"Thursday": {
		"en": "Thursday",
		"hk": "週四",
		"tw": "週四",
		"cn": "周四"
	},
	"Friday": {
		"en": "Friday",
		"tw": "週五",
		"hk": "週五",
		"cn": "周五"
	},
	"Saturday": {
		"en": "Saturday",
		"tw": "週六",
		"hk": "週六",
		"cn": "周六"
	},
	"Sunday": {
		"en": "Sunday",
		"tw": "周日",
		"hk": "周日",
		"cn": "周日"
	},
	"analysisSetting": {
		"en": "Chart Setting",
		"tw": "圖表設定",
		"hk": "圖表設定",
		"cn": "图表设定"
	},
	"analysisCreate": {
		"en": "Create Chart",
		"tw": "創建圖表",
		"hk": "創建圖表",
		"cn": "创建图表"
	},
	"analysisChartName": {
		"en": "Chart Name",
		"hk": "圖表名稱",
		"tw": "圖表名稱",
		"cn": "图表名称"
	},
	"antoPoolingEnabled": {
		"en": "Activate Planning？",
		"tw": "是否開啟計劃任務",
		"hk": "是否開啟計劃任務",
		"cn": "是否开启计划任务"
	},
	"antoPoolingTime": {
		"en": "Triggering time",
		"hk": "觸發時間",
		"tw": "觸發時間",
		"cn": "触发时间"
	},
	"tableDimension": {
		"en": "Multi dimensions",
		"hk": "多個維度",
		"tw": "多個維度",
		"cn": "多个维度"
	},
	"tableValue": {
		"en": "Multi values",
		"hk": "多個數值",
		"tw": "多個數值",
		"cn": "多个数值"
	},
	"barChart": {
		"en": "Bar Chart",
		"hk": "柱狀圖",
		"tw": "柱狀圖",
		"cn": "柱状图"
	},
	"barDimension": {
		"en": "0 or 1 dimension",
		"hk": "0或1個維度",
		"tw": "0或1個維度",
		"cn": "0或1个维度"
	},
	"barValue": {
		"en": "1 or multi values",
		"tw": "1個數值或多個數值",
		"hk": "1個數值或多個數值",
		"cn": "1个数值或多个数值"
	},
	"lineChart": {
		"en": "Line Chart",
		"tw": "折線圖",
		"hk": "折線圖",
		"cn": "折线图"
	},
	"lineDimension": {
		"en": "1 dimension",
		"tw": "1個維度",
		"hk": "1個維度",
		"cn": "1个维度"
	},
	"lineValue": {
		"en": "1 or multi values",
		"tw": "1個數值或多個數值",
		"hk": "1個數值或多個數值",
		"cn": "1个数值或多个数值"
	},
	"pieChart": {
		"en": "Pie Chart",
		"tw": "餅圖",
		"hk": "餅圖",
		"cn": "饼图"
	},
	"pieDimension": {
		"en": "1 dimension with 1 value",
		"tw": "1個維度1個數值",
		"hk": "1個維度1個數值",
		"cn": "1个维度1个数值"
	},
	"pieValue": {
		"en": "0 dimension with multi values",
		"tw": "0個維度多個數值",
		"hk": "0個維度多個數值",
		"cn": "0个维度多个数值"
	},
	"columnList": {
		"en": "Variable list",
		"tw": "字段列表",
		"hk": "字段列表",
		"cn": "字段列表"
	},
	"analysisChart": {
		"en": "Chart",
		"tw": "統計圖",
		"hk": "統計圖",
		"cn": "统计图"
	},
	"analysisTable": {
		"en": "Table",
		"tw": "統計表",
		"hk": "統計表",
		"cn": "统计表"
	},
	"columnCheckItem": {
		"en": "Multiple selection",
		"tw": "多選選項",
		"hk": "多選選項",
		"cn": "多选选项"
	},
	"columnRadioItem": {
		"en": "Single selection",
		"tw": "單選",
		"hk": "單選",
		"cn": "单选"
	},
	"alertIndex": {
		"en": "Code number",
		"tw": "序號",
		"hk": "序號",
		"cn": "序号"
	},
	"criticalValue": {
		"en": "Criticle value",
		"tw": "臨界值",
		"hk": "臨界值",
		"cn": "临界值"
	},
	"triggerCount": {
		"en": "No. of Triggering",
		"tw": "觸發次數",
		"hk": "觸發次數",
		"cn": "触发次数"
	},
	"triggerState": {
		"en": "Today Status",
		"tw": "今日狀態",
		"hk": "今日狀態",
		"cn": "今日状态"
	},
	"commonMLT": {
		"en": "Related articles",
		"tw": "相關資訊",
		"hk": "相關資訊",
		"cn": "相关资讯"
	},
	"dontShowMediaType": {
		"en": "Not listed in the following media types",
		"tw": "不顯示在下列媒體類型中",
		"hk": "不顯示在下列媒體類型中",
		"cn": "不显示在下列媒体类型中"
	},
	"unnamed": {
		"en": "Untitled Chart",
		"tw": "未命名圖表",
		"hk": "未命名圖表",
		"cn": "未命名图表"
	},
	"chartTitle": {
		"en": "Chart title",
		"tw": "圖表標題",
		"hk": "圖表標題",
		"cn": "图表标题"
	},
	"coordinateAxes": {
		"en": "Axis",
		"tw": "座標軸",
		"hk": "座標軸",
		"cn": "坐标轴"
	},
	"showDataCount": {
		"en": "Display of no. of data",
		"tw": "顯示數據條目數",
		"hk": "顯示數據條目數",
		"cn": "显示数据条目数"
	},
	"filterShowDataCount": {
		"en": "Display of no. of data after filtered",
		"tw": "對數據條目進行過濾顯示",
		"hk": "對數據條目進行過濾顯示",
		"cn": "对数据条目进行过滤显示"
	},
	"poolingSourcePut": {
		"en": "Pooling",
		"tw": "入庫",
		"hk": "入庫",
		"cn": "入库"
	},
	"poolingSourcePutText": {
		"en": "Added to the coding pool",
		"tw": "已導入樣本庫",
		"hk": "已導入樣本庫",
		"cn": "已导入样本库"
	},
	"poolingTestingText": {
		"en": "Added to the testing pool",
		"tw": "已導入測試庫",
		"hk": "已導入測試庫",
		"cn": "已导入测试库"
	},
	"poolingSourcePutSuccess": {
		"en": "Added",
		"tw": "已入",
		"hk": "已入",
		"cn": "已入"
	},
	"quickCliped": {
		"en": "Clipping",
		"tw": "一鍵剪報",
		"hk": "一鍵剪報",
		"cn": "一键剪报"
	},
	"commonIsCoded": {
		"en": "Coding?",
		"tw": "人工編碼",
		"hk": "人工編碼",
		"cn": "人工编码"
	},
	"commonCodeDate": {
		"en": "Coding Time",
		"hk": "編碼時間",
		"tw": "編碼時間",
		"cn": "编码时间"
	},
	"commonFeedCount": {
		"en": "Posts",
		"hk": "帖量",
		"tw": "帖量",
		"cn": "帖量"
	},
	"analysisChartFilter": {
		"en": "Filter in Chart",
		"tw": "圖表内篩選",
		"hk": "圖表内篩選",
		"cn": "图表内筛选"
	},
	"analysisChartCondition": {
		"en": "Chart settings",
		"tw": "製圖設置",
		"hk": "製圖設置",
		"cn": "制图设置"
	},
	"createFolder": {
		"en": "Create Folder",
		"tw": "創建文件夾",
		"hk": "創建文件夾",
		"cn": "创建文件夹"
	},
	"createCharts": {
		"en": "Create Charts",
		"tw": "創建圖表",
		"hk": "創建圖表",
		"cn": "创建图表"
	},
	"allCharts": {
		"en": "All Charts",
		"tw": "全部圖表",
		"hk": "全部圖表",
		"cn": "全部图表"
	},
	"isExists": {
		"en": "Existed",
		"tw": "已存在此項",
		"hk": "已存在此項",
		"cn": "已存在此项"
	},
	"deleteProfileTitle": {
		"en": "Are you sure to delete this chart?",
		"tw": "確認要刪除此圖表嗎？",
		"hk": "確認要刪除此圖表嗎？",
		"cn": "确认要删除此图表吗？"
	},
	"deleteProfileContent": {
		"en": "You cannot retore it after deletion",
		"tw": "此操作無法恢復",
		"hk": "此操作無法恢復",
		"cn": "此操作无法恢复"
	},
	"titleTextFilter": {
		"en": "Filter in title",
		"tw": "標題中是否含有以下內容",
		"hk": "標題中是否含有以下內容",
		"cn": "标题中是否含有以下内容"
	},
	"contentTextFilter": {
		"en": "Filter in content",
		"tw": "正文中是否含有以下內容",
		"hk": "正文中是否含有以下內容",
		"cn": "正文中是否含有以下內容"
	},
	"textFilter": {
		"en": "Filter in text",
		"tw": "是否含有以下內容",
		"hk": "是否含有以下內容",
		"cn": "是否含有以下內容"
	},
	"wordsNumber": {
		"en": "Words",
		"tw": "文章字數",
		"hk": "文章字數",
		"cn": "文章字数"
	},
	"checkChildrem": {
		"en": "Check the item",
		"tw": "選中以下選項",
		"hk": "選中以下選項",
		"cn": "选中以下选项"
	},
	"codedState": {
		"en": "Coded status",
		"tw": "編碼狀態",
		"hk": "編碼狀態",
		"cn": "编码状态"
	},
	"commonNoMlt": {
		"en": "No data",
		"tw": "無相關資訊",
		"hk": "無相關資訊",
		"cn": "无相关资讯"
	},
	"香港": {
		"en": "Hong Kong",
		"tw": "香港",
		"hk": "香港",
		"cn": "香港"
	},
	"澳門": {
		"en": "Macao",
		"tw": "澳門",
		"hk": "澳門",
		"cn": "澳门"
	},
	"內地": {
		"en": null,
		"tw": "內地",
		"hk": "內地",
		"cn": "内地"
	},
	"台灣": {
		"en": "Taiwan",
		"tw": "台灣",
		"hk": "台灣",
		"cn": "台湾"
	},
	"海外中文": {
		"en": null,
		"tw": "海外中文",
		"hk": "海外中文",
		"cn": "海外中文"
	},
	"海外外文": {
		"en": null,
		"tw": "海外外文",
		"hk": "海外外文",
		"cn": "海外中文"
	},
	"poolingDateSetting": {
		"en": "Please set the time for this subject",
		"tw": "請設定此話題研究時間",
		"hk": "請設定此話題研究時間",
		"cn": "请设定此话题研究时间"
	},
	"noAlert": {
		"en": "No Alert record",
		"tw": "暫無預警記錄",
		"hk": "暫無預警記錄",
		"cn": "暂无预警记录"
	},
	"today": {
		"en": "Today",
		"hk": "今天",
		"tw": "今天",
		"cn": "今天"
	},
	"7day": {
		"en": "Last 7 days",
		"tw": "最近7天",
		"hk": "最近7天",
		"cn": "最近7天"
	},
	"30day": {
		"en": "Last 30 days",
		"tw": "最近30天",
		"hk": "最近30天",
		"cn": "最近30天"
	},
	"onlyShowTopic": {
		"en": "Show Topic",
		"tw": "只顯示主帖",
		"hk": "只顯示主帖",
		"cn": "只显示主帖"
	},
	"warning": {
		"en": "Warning!",
		"tw": "重要！",
		"hk": "重要！",
		"cn": "重要！"
	},
	"compareLost": {
		"en": "Compare object lost",
		"tw": "比較對象丟失",
		"hk": "比較對象丟失",
		"cn": "比较对象丢失"
	},
	"compareLostText": {
		"en": "Refresh the page to cause the comparison object to lose, please return to the subject list to re operate",
		"tw": "刷新頁面導致比較對象丟失，請回到話題列表重新操作",
		"hk": "刷新頁面導致比較對象丟失，請回到話題列表重新操作",
		"cn": "刷新页面导致比较对象丢失，请回到话题列表重新操作"
	},
	"commonReputationText": {
		"en": "Value rule：the average number of the affective values of every article in a day. 0~0.5 is a negative emotion, and 0.5~1 is a positive emotion.",
		"tw": "取值規則：每天所有文章情感值的平均數。0~0.5為負面情感，0.5~1為正面情感。",
		"hk": "取值規則：每天所有文章情感值的平均數。0~0.5為負面情感，0.5~1為正面情感。",
		"cn": "取值规则：每天所有文章情感值的平均数。0~0.5为负面情感，0.5~1为正面情感。"
	},
	"updateError": {
		"en": "Please enter a date",
		"tw": "請填寫日期",
		"hk": "請填寫日期",
		"cn": "请填写日期"
	},
	"updatePDFError": {
		"en": "Please upload the file",
		"tw": "請上傳文件",
		"hk": "請上傳文件",
		"cn": "请上传文件"
	},
	"loginConflictTitle": {
		"en": "Logout Notification",
		"tw": "登出通知",
		"hk": "登出通知",
		"cn": "登出通知"
	},
	"loginConflictContent": {
		"en": "Your account has been logged in on another device, if you didn't intend to log in to your account from this device, you can protect your account by changing your password.",
		"tw": "閣下之帳號已在其他設備登錄，本帳號已被登出。若非本人操作，帳號信息可能已洩露，請及時修改密碼。",
		"hk": "閣下之帳號已在其他設備登錄，本帳號已被登出。若非本人操作，帳號信息可能已洩露，請及時修改密碼。",
		"cn": "您的帐号已在其他设备登录，本帐号已被登出。若非本人操作，帐号信息可能已泄露，请及时修改密码。"
	},
	"sourceSearchNoData": {
		"en": "No Data",
		"tw": "無匹配內容",
		"hk": "無匹配內容",
		"cn": "无匹配内容"
	},
	"readyPooling": {
		"en": "Is ready to 「{{pooling}}」",
		"tw": "正在準備進行 「{{pooling}}」",
		"hk": "正在準備進行 「{{pooling}}」",
		"cn": "正在准备进行 「{{pooling}}」"
	},
	"errorPooling": {
		"en": "「{{pooling}}」 Run the error, Please refresh the page and try again or contact the administrator.",
		"tw": "「{{pooling}}」 運行錯誤，請刷新頁面後重試或聯繫管理員",
		"hk": "「{{pooling}}」 運行錯誤，請刷新頁面後重試或聯繫管理員",
		"cn": "「{{pooling}}」 运行错误，请刷新页面后重试或联系管理员"
	},
	"poolingNow": {
		"en": "Underway 「{{pooling}}」",
		"tw": "正在進行 「{{pooling}}」",
		"hk": "正在進行 「{{pooling}}」",
		"cn": "正在进行 「{{pooling}}」"
	},
	"poolingNowTime": {
		"en": "Expected time required{{time}}",
		"tw": "預計所需時間{{time}}",
		"hk": "預計所需時間{{time}}",
		"cn": "预计所需时间{{time}}"
	},
	"hours": {
		"en": "hours",
		"tw": "小時",
		"hk": "小時",
		"cn": "小时"
	},
	"minutes": {
		"en": "minutes and",
		"tw": "分",
		"hk": "分",
		"cn": "分"
	},
	"seconds": {
		"en": "seconds",
		"tw": "秒",
		"hk": "秒",
		"cn": "秒"
	},
	"dataStorage": {
		"en": "Data storage…",
		"tw": "數據存儲中…",
		"hk": "數據存儲中…",
		"cn": "数据存储中…"
	},
	"standardLine": {
		"en": "Standard Line",
		"tw": "標準折線圖",
		"hk": "標準折線圖",
		"cn": "标准折线图"
	},
	"StackLine": {
		"en": "Stack Line",
		"tw": "堆積折綫圖",
		"hk": "堆積折綫圖",
		"cn": "堆叠折线图"
	},
	"standardBar": {
		"en": "Standard Bar",
		"tw": "標準柱狀圖",
		"hk": "標準柱狀圖",
		"cn": "标准柱状图"
	},
	"StackBar": {
		"en": "Stack Bar",
		"tw": "堆積柱狀圖",
		"hk": "堆積柱狀圖",
		"cn": "堆叠柱状图"
	},
	"standardPie": {
		"en": null,
		"tw": "標準餅圖",
		"hk": "標準餅圖",
		"cn": "标准饼图"
	},
	"annularPie": {
		"en": null,
		"tw": "標準環形圖",
		"hk": "標準環形圖",
		"cn": "标准环形图"
	},
	"standardRBar": {
		"en": null,
		"tw": "標準條形圖",
		"hk": "標準條形圖",
		"cn": "标准条形图"
	},
	"StackRBar": {
		"en": null,
		"tw": "堆積條形圖",
		"hk": "堆積條形圖",
		"cn": "堆叠条形图"
	},
	"monitorTrend": {
		"en": "Trend",
		"tw": "聲量",
		"hk": "聲量",
		"cn": "声量"
	},
	"monitorTimeLine": {
		"en": "Communication Path",
		"tw": "傳播路徑",
		"hk": "傳播路徑",
		"cn": "传播路径"
	},
	"monitorSentiment": {
		"en": "Reputation",
		"tw": "美譽度",
		"hk": "美譽度",
		"cn": "美誉度"
	},
	"monitorWordCloud": {
		"en": "Word Cloud",
		"hk": "焦點熱詞",
		"tw": "焦點熱詞",
		"cn": "焦点热词"
	},
	"monitorLeader": {
		"en": "Leader",
		"tw": "意見領袖",
		"hk": "意見領袖",
		"cn": "意见领袖"
	},
	"saveImg": {
		"en": "Save as picture",
		"tw": "保存為圖片",
		"hk": "保存為圖片",
		"cn": "保存为图片"
	},
	"checkTime": {
		"en": "Please select the time",
		"tw": "請選擇時間",
		"hk": "請選擇時間",
		"cn": "请选择时间"
	},
	"ViewOriginal": {
		"en": "View original",
		"tw": "查看原文",
		"hk": "查看原文",
		"cn": "查看原文"
	},
	"showTopTen": {
		"en": "Show only the top ten",
		"tw": "僅顯示前十",
		"hk": "僅顯示前十",
		"cn": "仅显示前十"
	},
	"exportTestingData": {
		"en": "Export Testing Data",
		"tw": "導出測試數據",
		"hk": "導出測試數據",
		"cn": "导出测试数据"
	},
	"showSamplingSubject": {
		"en": "Show sample Subject",
		"tw": "查看抽樣庫",
		"hk": "查看抽樣庫",
		"cn": "查看抽样库"
	},
	"deleteSamplingSubject": {
		"en": "Delete",
		"tw": "刪除抽樣庫",
		"hk": "刪除抽樣庫",
		"cn": "删除抽样库"
	},
	"noSamplingSubjectDada": {
		"en": "NO Data",
		"tw": "該話題暫無抽樣庫",
		"hk": "該話題暫無抽樣庫",
		"cn": "该话题暂无抽样库"
	},
	"scopeDataCount": {
		"en": "At present, there are {{count}} sampling data",
		"tw": "當前可抽樣數據量共{{count}}筆",
		"hk": "當前可抽樣數據量共{{count}}筆",
		"cn": "当前可抽样数据量共{{count}}条"
	},
	"inputSamplingSubjectName": {
		"en": "Please input sample subject name",
		"tw": "請填寫抽樣庫名稱",
		"hk": "請填寫抽樣庫名稱",
		"cn": "请填写抽样库名称"
	},
	"pleaseSelectSamplingSubject": {
		"en": "Please select a sample subject",
		"tw": "請選擇抽樣庫",
		"hk": "請選擇抽樣庫",
		"cn": "请选择抽样库"
	},
	"addSamplingFunction": {
		"en": "Please add the sampling method",
		"tw": "請添加抽樣方法",
		"hk": "請添加抽樣方法",
		"cn": "请添加抽样方法"
	},
	"inputFillComplete": {
		"en": "Please fill in the complete",
		"tw": "請填寫完整",
		"hk": "請填寫完整",
		"cn": "请填写完整"
	},
	"showSamplingData": {
		"en": "View sample data",
		"tw": "查看抽樣數據",
		"hk": "查看抽樣數據",
		"cn": "查看抽样数据"
	},
	"quit": {
		"en": "Quit",
		"tw": "退出",
		"hk": "退出",
		"cn": "退出"
	},
	"selectSamplingSubject": {
		"en": "Select a sample subject",
		"tw": "選擇抽樣庫",
		"hk": "選擇抽樣庫",
		"cn": "选择抽样库"
	},
	"samplingFunction": {
		"en": "Sampling Method",
		"tw": "抽樣方法",
		"hk": "抽樣方法",
		"cn": "抽样方法"
	},
	"samplingSuccess": {
		"en": "Complete sampling",
		"tw": "完成抽樣",
		"hk": "完成抽樣",
		"cn": "完成抽样"
	},
	"selectHaveSampling": {
		"en": "Select the existing sample library",
		"tw": "選擇已有樣本庫",
		"hk": "選擇已有樣本庫",
		"cn": "选择已有样本库"
	},
	"existingSampleLibrary": {
		"en": "Existing sample library",
		"tw": "已有抽樣庫",
		"hk": "已有抽樣庫",
		"cn": "已有抽样库"
	},
	"samplingSubjectName": {
		"en": "Sample Subject Name",
		"tw": "抽樣庫名稱",
		"hk": "抽樣庫名稱",
		"cn": "抽样库名称"
	},
	"copySubjectToSampling": {
		"en": "Copy the overall topic settings",
		"tw": "複製總體話題設置",
		"hk": "複製總體話題設置",
		"cn": "复制总体话题设置"
	},
	"createSamplingSubject": {
		"en": "Create Sample Subject",
		"tw": "新建抽樣庫",
		"hk": "新建抽樣庫",
		"cn": "新建抽样库"
	},
	"samplingTime": {
		"en": "Ongoing sampling / expected time",
		"tw": "正在進行抽樣 / 預計所需時間",
		"hk": "正在進行抽樣 / 預計所需時間",
		"cn": "正在进行抽样 / 预计所需时间"
	},
	"selectFunction": {
		"en": "Selection method",
		"tw": "選取方法",
		"hk": "選取方法",
		"cn": "选取方法"
	},
	"random": {
		"en": "Random",
		"tw": "隨機",
		"hk": "隨機",
		"cn": "随机"
	},
	"selectSortAsc": {
		"en": "Select the sort (ascending)",
		"tw": "排序選取（升序）",
		"hk": "排序選取（升序）",
		"cn": "排序选取（升序）"
	},
	"selectSortDesc": {
		"en": "Select the sort (descending)",
		"tw": "排序選取（降序）",
		"hk": "排序選取（降序）",
		"cn": "排序选取（降序）"
	},
	"selectCount": {
		"en": "count",
		"tw": "選取量",
		"hk": "選取量",
		"cn": "选取量"
	},
	"addRangeFilterConditions": {
		"en": "Add range filter conditions",
		"tw": "添加範圍篩選條件",
		"hk": "添加範圍篩選條件",
		"cn": "添加范围筛选条件"
	},
	"sampling": {
		"en": "Code base sampling",
		"tw": "編碼庫抽樣",
		"hk": "編碼庫抽樣",
		"cn": "编码库抽样"
	},
	"selctRange": {
		"en": "Selection range",
		"tw": "選取範圍",
		"hk": "選取範圍",
		"cn": "选取范围"
	},
	"populationBase": {
		"en": "Population Base",
		"hk": "總體庫",
		"tw": "總體庫",
		"cn": "总体库"
	},
	"dataMigration": {
		"en": "Data migration",
		"hk": "數據遷移",
		"tw": "數據遷移",
		"cn": "数据迁移"
	},
	"dataMigrationSuccess": {
		"en": "Data migration success",
		"hk": "數據遷移成功",
		"tw": "數據遷移成功",
		"cn": "数据迁移成功"
	},
	"seeSubject": {
		"en": "See Subject",
		"hk": "查看話題",
		"tw": "查看話題",
		"cn": "查看话题"
	},
	"newColumn": {
		"en": "New Column",
		"hk": "新增組合",
		"tw": "新增組合",
		"cn": "新增组合"
	},
	"addSubcondition": {
		"en": "Add Subcondition",
		"hk": "添加子條件",
		"tw": "添加子條件",
		"cn": "添加子条件"
	},
	"isTopic": {
		"en": "Topic",
		"hk": "主帖",
		"tw": "主帖",
		"cn": "主贴"
	},
	"percentageLine": {
		"en": "Percentage Line",
		"hk": "百分比線圖",
		"tw": "百分比線圖",
		"cn": "百分比线图"
	},
	"percentageStack": {
		"en": "Percentage Stacked",
		"hk": "百分比堆積圖",
		"tw": "百分比堆積圖",
		"cn": "百分比堆积图"
	},
	"percentageBar": {
		"en": "Percentage Stacked",
		"hk": "百分比堆積圖",
		"tw": "百分比堆積圖",
		"cn": "百分比堆积图"
	},
	"showCount": {
		"en": "Show Count",
		"hk": "顯示數值",
		"tw": "顯示數值",
		"cn": "显示数值"
	},
	"subtitle": {
		"en": "subtitle",
		"hk": "副標題",
		"tw": "副標題",
		"cn": "副标题"
	},
	"DisplayPercentage": {
		"en": "Display percentage",
		"hk": "顯示百分比",
		"tw": "顯示百分比",
		"cn": "显示百分比"
	},
	"DisplayDataCount": {
		"en": "Display data totals",
		"hk": "顯示數據總計",
		"tw": "顯示數據總計",
		"cn": "显示数据总计"
	},
	"Row": {
		"en": "Row",
		"hk": "行",
		"tw": "行",
		"cn": "行"
	},
	"List": {
		"en": "list",
		"hk": "列",
		"tw": "列",
		"cn": "列"
	},
	"pleaseSelect": {
		"en": "Please select",
		"hk": "請選擇",
		"tw": "請選擇",
		"cn": "请选择"
	},
	"importCategoryConfimTitel": {
		"en": "Are you sure synchronization category?",
		"hk": "您確定同步類目嗎？",
		"tw": "您確定同步類目嗎？",
		"cn": "您确定同步类目吗？"
	},
	"importCategoryConfimText": {
		"en": "This operation will clear all categories of the subject",
		"hk": "此操作會清空當前話題的所有類目",
		"tw": "此操作會清空當前話題的所有類目",
		"cn": "此操作会清空当前话题的所有类目"
	},
	"NewCombination": {
		"en": "new combination",
		"hk": "新增組合",
		"tw": "新增組合",
		"cn": "新增组合"
	},
	"DailyExpress": {
		"en": "Daily Express",
		"hk": "每日速遞",
		"tw": "每日速遞",
		"cn": "每日速递"
	},
	"unusedMessage": {
		"en": "You will be logged out after {{time}} minutes",
		"tw": "{{time}} 分鐘後帳號將被強制登出",
		"hk": "{{time}} 分鐘後帳號將被強制登出",
		"cn": "{{time}} 分钟后账号将被强制登出"
	},
	"unusedDescription": {
		"en": "You have left the platform unused for {{unusedTime}} minutes, and will be logged out after {{spareTime}} minutes. All data will be cleared after logged out. Please download the data and information you need. Thank you.",
		"tw": "您的帳號已閒置 {{unusedTime}} 分鐘，將於 {{spareTime}} 分鐘后被強制登出",
		"hk": "您的帳號已閒置 {{unusedTime}} 分鐘，將於 {{spareTime}} 分鐘后被強制登出",
		"cn": "您的账号已闲置 {{unusedTime}} 分钟，将于 {{spareTime}} 分钟后被强制登出"
	},
	"autoLogoutTitle": {
		"en": "Your account has been logged out",
		"tw": "閣下的帳號已登出",
		"hk": "閣下的帳號已登出",
		"cn": "您的账号已退出"
	},
	"autoLogoutContent": {
		"en": "There is no operation on the platform for a long time. As to ensure effective use of resources, you have been automatically logged out.",
		"tw": "由於您長時間在平台中沒有任何操作，為了更有效運用資源，帳號已強制登出。",
		"hk": "由於您長時間在平台中沒有任何操作，為了更有效運用資源，帳號已強制登出。",
		"cn": "由于您长时间在平台中没有任何操作，为了更有效运用资源，账号已强制登出。"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/i18n/translation.yml
 ** module id = 1785
 ** module chunks = 0
 **/